import { InjectionToken } from '@angular/core';

export interface TempCobMeta {
  id: number;
  code: string;
  name: string;
}

export const TEMP_COB_DATA = new InjectionToken('TempCobMetaData');

export const TEMP_COB_DATA_DEFAULT: TempCobMeta[] = [
  {
    id: 1,
    code: '102',
    name: 'Fee',
  },
  {
    id: 2,
    code: '110',
    name: 'Project Third Party Liability',
  },
  {
    id: 3,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 4,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 5,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 6,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 7,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 8,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 9,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 10,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 11,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 12,
    code: '397',
    name: 'Builders All Risks',
  },
  {
    id: 13,
    code: '429',
    name: 'Delay In Startup',
  },
  {
    id: 14,
    code: '432',
    name: 'Contractual Financial Loss',
  },
  {
    id: 15,
    code: '569',
    name: 'FIRE',
  },
  {
    id: 16,
    code: 'CMB',
    name: 'CONTRACTORS ALL RISKS TP EL',
  },
  {
    id: 17,
    code: 'DET',
    name: 'Defective Title',
  },
  {
    id: 18,
    code: 'XTP',
    name: 'Excess Third Party Liabilities',
  },
  {
    id: 19,
    code: '102',
    name: 'Fee',
  },
  {
    id: 20,
    code: '110',
    name: 'Project Third Party Liability',
  },
  {
    id: 21,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 22,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 23,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 24,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 25,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 26,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 27,
    code: '397',
    name: 'Builders All Risks',
  },
  {
    id: 28,
    code: '429',
    name: 'Delay In Startup',
  },
  {
    id: 29,
    code: '432',
    name: 'Contractual Financial Loss',
  },
  {
    id: 30,
    code: '569',
    name: 'FIRE',
  },
  {
    id: 31,
    code: 'XTP',
    name: 'Excess Third Party Liabilities',
  },
  {
    id: 32,
    code: '101',
    name: 'VAT',
  },
  {
    id: 33,
    code: '102',
    name: 'Fee',
  },
  {
    id: 34,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 35,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 36,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 37,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 38,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 39,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 40,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 41,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 42,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 43,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 44,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 45,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 46,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 47,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 48,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 49,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 50,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 51,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 52,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 53,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 54,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 55,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 56,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 57,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 58,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 59,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 60,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 61,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 62,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 63,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 64,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 65,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 66,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 67,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 68,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 69,
    code: '303',
    name: 'Computers',
  },
  {
    id: 70,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 71,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 72,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 73,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 74,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 75,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 76,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 77,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 78,
    code: '320',
    name: 'Money',
  },
  {
    id: 79,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 80,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 81,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 82,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 83,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 84,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 85,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 86,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 87,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 88,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 89,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 90,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 91,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 92,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 93,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 94,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 95,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 96,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 97,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 98,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 99,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 100,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 101,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 102,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 103,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 104,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 105,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 106,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 107,
    code: '410',
    name: 'Crime',
  },
  {
    id: 108,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 109,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 110,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 111,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 112,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 113,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 114,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 115,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 116,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 117,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 118,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 119,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 120,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 121,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 122,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 123,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 124,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 125,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 126,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 127,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 128,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 129,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 130,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 131,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 132,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 133,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 134,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 135,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 136,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 137,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 138,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 139,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 140,
    code: '004',
    name: 'War',
  },
  {
    id: 141,
    code: '005',
    name: 'Property Damage',
  },
  {
    id: 142,
    code: '012',
    name: 'Erection All Risks',
  },
  {
    id: 143,
    code: '102',
    name: 'Fee',
  },
  {
    id: 144,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 145,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 146,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 147,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 148,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 149,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 150,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 151,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 152,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 153,
    code: '303',
    name: 'Computers',
  },
  {
    id: 154,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 155,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 156,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 157,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 158,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 159,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 160,
    code: '410',
    name: 'Crime',
  },
  {
    id: 161,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 162,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 163,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 164,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 165,
    code: 'API',
    name: 'Aviation Products Liability',
  },
  {
    id: 166,
    code: 'ARE',
    name: 'Airport Liability',
  },
  {
    id: 167,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 168,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 169,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 170,
    code: 'MEP',
    name: 'Environmental PI',
  },
  {
    id: 171,
    code: 'PUN',
    name: 'Punitive Damages',
  },
  {
    id: 172,
    code: '012',
    name: 'Erection All Risks',
  },
  {
    id: 173,
    code: '101',
    name: 'VAT',
  },
  {
    id: 174,
    code: '102',
    name: 'Fee',
  },
  {
    id: 175,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 176,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 177,
    code: '110',
    name: 'Project Third Party Liability',
  },
  {
    id: 178,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 179,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 180,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 181,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 182,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 183,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 184,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 185,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 186,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 187,
    code: '154',
    name: 'Environmental Damages',
  },
  {
    id: 188,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 189,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 190,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 191,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 192,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 193,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 194,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 195,
    code: '277',
    name: 'Surplus Lines Tax',
  },
  {
    id: 196,
    code: '293',
    name: 'Delay in Completion',
  },
  {
    id: 197,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 198,
    code: '303',
    name: 'Computers',
  },
  {
    id: 199,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 200,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 201,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 202,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 203,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 204,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 205,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 206,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 207,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 208,
    code: '318',
    name: 'Exhibition',
  },
  {
    id: 209,
    code: '320',
    name: 'Money',
  },
  {
    id: 210,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 211,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 212,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 213,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 214,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 215,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 216,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 217,
    code: '357',
    name: 'Earthquake',
  },
  {
    id: 218,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 219,
    code: '360',
    name: 'Loss of Anticipated Rental Income',
  },
  {
    id: 220,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 221,
    code: '367',
    name: 'Forfeiture of Lease',
  },
  {
    id: 222,
    code: '369',
    name: 'Rights of Light',
  },
  {
    id: 223,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 224,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 225,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 226,
    code: '396',
    name: 'Existing Structures',
  },
  {
    id: 227,
    code: '397',
    name: 'Builders All Risks',
  },
  {
    id: 228,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 229,
    code: '410',
    name: 'Crime',
  },
  {
    id: 230,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 231,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 232,
    code: '425',
    name: 'Legal Indemnity',
  },
  {
    id: 233,
    code: '429',
    name: 'Delay In Startup',
  },
  {
    id: 234,
    code: '432',
    name: 'Contractual Financial Loss',
  },
  {
    id: 235,
    code: '433',
    name: 'Crisis Management',
  },
  {
    id: 236,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 237,
    code: '443',
    name: 'Flood Flash',
  },
  {
    id: 238,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 239,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 240,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 241,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 242,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 243,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 244,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 245,
    code: '569',
    name: 'FIRE',
  },
  {
    id: 246,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 247,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 248,
    code: '984',
    name: 'Lockton Excess Liability Facility',
  },
  {
    id: 249,
    code: 'CMB',
    name: 'CONTRACTORS ALL RISKS TP EL',
  },
  {
    id: 250,
    code: 'XTP',
    name: 'Excess Third Party Liabilities',
  },
  {
    id: 251,
    code: '102',
    name: 'Fee',
  },
  {
    id: 252,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 253,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 254,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 255,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 256,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 257,
    code: '185',
    name: 'PI Lloyds Insurance Brokers',
  },
  {
    id: 258,
    code: '191',
    name: 'PI Underwriter Agents & Managers',
  },
  {
    id: 259,
    code: '101',
    name: 'VAT',
  },
  {
    id: 260,
    code: '102',
    name: 'Fee',
  },
  {
    id: 261,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 262,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 263,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 264,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 265,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 266,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 267,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 268,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 269,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 270,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 271,
    code: '154',
    name: 'Environmental Damages',
  },
  {
    id: 272,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 273,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 274,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 275,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 276,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 277,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 278,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 279,
    code: '277',
    name: 'Surplus Lines Tax',
  },
  {
    id: 280,
    code: '293',
    name: 'Delay in Completion',
  },
  {
    id: 281,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 282,
    code: '303',
    name: 'Computers',
  },
  {
    id: 283,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 284,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 285,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 286,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 287,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 288,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 289,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 290,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 291,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 292,
    code: '318',
    name: 'Exhibition',
  },
  {
    id: 293,
    code: '320',
    name: 'Money',
  },
  {
    id: 294,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 295,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 296,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 297,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 298,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 299,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 300,
    code: '357',
    name: 'Earthquake',
  },
  {
    id: 301,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 302,
    code: '360',
    name: 'Loss of Anticipated Rental Income',
  },
  {
    id: 303,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 304,
    code: '367',
    name: 'Forfeiture of Lease',
  },
  {
    id: 305,
    code: '369',
    name: 'Rights of Light',
  },
  {
    id: 306,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 307,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 308,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 309,
    code: '396',
    name: 'Existing Structures',
  },
  {
    id: 310,
    code: '397',
    name: 'Builders All Risks',
  },
  {
    id: 311,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 312,
    code: '410',
    name: 'Crime',
  },
  {
    id: 313,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 314,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 315,
    code: '425',
    name: 'Legal Indemnity',
  },
  {
    id: 316,
    code: '429',
    name: 'Delay In Startup',
  },
  {
    id: 317,
    code: '432',
    name: 'Contractual Financial Loss',
  },
  {
    id: 318,
    code: '433',
    name: 'Crisis Management',
  },
  {
    id: 319,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 320,
    code: '443',
    name: 'Flood Flash',
  },
  {
    id: 321,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 322,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 323,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 324,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 325,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 326,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 327,
    code: '569',
    name: 'FIRE',
  },
  {
    id: 328,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 329,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 330,
    code: '984',
    name: 'Lockton Excess Liability Facility',
  },
  {
    id: 331,
    code: 'XTP',
    name: 'Excess Third Party Liabilities',
  },
  {
    id: 332,
    code: '102',
    name: 'Fee',
  },
  {
    id: 333,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 334,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 335,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 336,
    code: '126',
    name: 'PI Solicitors Excess',
  },
  {
    id: 337,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 338,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 339,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 340,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 341,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 342,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 343,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 344,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 345,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 346,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 347,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 348,
    code: '189',
    name: 'Asset Protection for Partnerships',
  },
  {
    id: 349,
    code: '190',
    name: 'Asset Protection',
  },
  {
    id: 350,
    code: '191',
    name: 'PI Underwriter Agents & Managers',
  },
  {
    id: 351,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 352,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 353,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 354,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 355,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 356,
    code: 'PAEN',
    name: 'PI Architects Engineers and Construction non USA',
  },
  {
    id: 357,
    code: 'PAEU',
    name: 'PI Architects Engineers & Construction Related Inc USA',
  },
  {
    id: 358,
    code: 'PIAU',
    name: 'Prof Indty Accountants Incl USA',
  },
  {
    id: 359,
    code: 'PIAX',
    name: 'Prof Indty Accountants Excl USA',
  },
  {
    id: 360,
    code: 'PIMU',
    name: 'Prof Indty Miscellaneous USA',
  },
  {
    id: 361,
    code: 'PIMX',
    name: 'Prof Indty Miscellaneous Excl USA',
  },
  {
    id: 362,
    code: 'PISE',
    name: 'Prof Indty Solicitors Excl USA',
  },
  {
    id: 363,
    code: 'PISU',
    name: 'Prof Indty Solicitors USA',
  },
  {
    id: 364,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 365,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 366,
    code: 'CYPD',
    name: 'Cyber Property Damage',
  },
  {
    id: 367,
    code: 'CYRH',
    name: 'Cyber Reputational Harm',
  },
  {
    id: 368,
    code: 'PIME',
    name: 'Prof Indty Media',
  },
  {
    id: 369,
    code: 'PITE',
    name: 'Prof Indty Technology',
  },
  {
    id: 370,
    code: '102',
    name: 'Fee',
  },
  {
    id: 371,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 372,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 373,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 374,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 375,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 376,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 377,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 378,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 379,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 380,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 381,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 382,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 383,
    code: '212',
    name: 'Minibus',
  },
  {
    id: 384,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 385,
    code: '254',
    name: 'Motor Laid Up',
  },
  {
    id: 386,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 387,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 388,
    code: '289',
    name: 'Home and Motor Portfolio',
  },
  {
    id: 389,
    code: '294',
    name: 'AMOC Private Car',
  },
  {
    id: 390,
    code: '295',
    name: 'FOC Private Car',
  },
  {
    id: 391,
    code: '296',
    name: 'JEC Collector',
  },
  {
    id: 392,
    code: '297',
    name: 'JEC Home',
  },
  {
    id: 393,
    code: '298',
    name: 'JEC Motor Scheme',
  },
  {
    id: 394,
    code: '299',
    name: 'JEC Private Car',
  },
  {
    id: 395,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 396,
    code: '303',
    name: 'Computers',
  },
  {
    id: 397,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 398,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 399,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 400,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 401,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 402,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 403,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 404,
    code: '341',
    name: 'Household Contractors Commercial',
  },
  {
    id: 405,
    code: '372',
    name: 'Household',
  },
  {
    id: 406,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 407,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 408,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 409,
    code: '398',
    name: 'Jewellery',
  },
  {
    id: 410,
    code: '399',
    name: 'Collections',
  },
  {
    id: 411,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 412,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 413,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 414,
    code: '438',
    name: 'PCGB Private Car',
  },
  {
    id: 415,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 416,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 417,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 418,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 419,
    code: '475',
    name: 'Lockton Home',
  },
  {
    id: 420,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 421,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 422,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 423,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 424,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 425,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 426,
    code: '851',
    name: 'BDC Motor Scheme',
  },
  {
    id: 427,
    code: '852',
    name: 'BDC Collector',
  },
  {
    id: 428,
    code: '853',
    name: 'BDC Private Car',
  },
  {
    id: 429,
    code: '854',
    name: 'BDC Home',
  },
  {
    id: 430,
    code: '855',
    name: 'BDC Portfolio',
  },
  {
    id: 431,
    code: '886',
    name: 'MCUK Motor Scheme',
  },
  {
    id: 432,
    code: '887',
    name: 'MCUK Collector',
  },
  {
    id: 433,
    code: '888',
    name: 'MCUK Household Scheme',
  },
  {
    id: 434,
    code: '889',
    name: 'MCUK Private Car',
  },
  {
    id: 435,
    code: '890',
    name: 'LCUK Motor Scheme',
  },
  {
    id: 436,
    code: '891',
    name: 'LCUK Collector',
  },
  {
    id: 437,
    code: '892',
    name: 'LCUK Home',
  },
  {
    id: 438,
    code: '893',
    name: 'LCUK Private Car',
  },
  {
    id: 439,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 440,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 441,
    code: '960',
    name: 'AMOC Motor Insurance Scheme',
  },
  {
    id: 442,
    code: '961',
    name: 'AMOC Home',
  },
  {
    id: 443,
    code: '962',
    name: 'Classic Car Citroen Car Club',
  },
  {
    id: 444,
    code: '963',
    name: 'AXA Collector',
  },
  {
    id: 445,
    code: '966',
    name: 'AXA Specialist Vehicle',
  },
  {
    id: 446,
    code: '968',
    name: 'JRC AMOC Household',
  },
  {
    id: 447,
    code: '970',
    name: 'FOC Motor Scheme',
  },
  {
    id: 448,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 449,
    code: '973',
    name: 'AMOC Collector',
  },
  {
    id: 450,
    code: '974',
    name: 'FOC Collector',
  },
  {
    id: 451,
    code: '976',
    name: 'FOC Home',
  },
  {
    id: 452,
    code: '977',
    name: 'Masterpiece Motor',
  },
  {
    id: 453,
    code: '978',
    name: 'Masterpiece Household',
  },
  {
    id: 454,
    code: '979',
    name: 'Masterpiece Combined',
  },
  {
    id: 455,
    code: '987',
    name: "Ferrari Owners' Club Household",
  },
  {
    id: 456,
    code: '992',
    name: 'PCGB Motor Scheme',
  },
  {
    id: 457,
    code: '993',
    name: 'PCGB Home',
  },
  {
    id: 458,
    code: '994',
    name: 'PCGB Collector',
  },
  {
    id: 459,
    code: '102',
    name: 'Fee',
  },
  {
    id: 460,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 461,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 462,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 463,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 464,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 465,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 466,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 467,
    code: '126',
    name: 'PI Solicitors Excess',
  },
  {
    id: 468,
    code: '129',
    name: 'Prof Indty E&O Miscellaneous XS',
  },
  {
    id: 469,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 470,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 471,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 472,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 473,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 474,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 475,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 476,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 477,
    code: '168',
    name: 'Prof Indty Will Writers',
  },
  {
    id: 478,
    code: '170',
    name: 'Dental Malpractice',
  },
  {
    id: 479,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 480,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 481,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 482,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 483,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 484,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 485,
    code: '236',
    name: 'Prof Indty Property Managers',
  },
  {
    id: 486,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 487,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 488,
    code: '284',
    name: 'PI Insolvency Practitioners',
  },
  {
    id: 489,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 490,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 491,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 492,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 493,
    code: '410',
    name: 'Crime',
  },
  {
    id: 494,
    code: '428',
    name: 'Office Guardian',
  },
  {
    id: 495,
    code: '839',
    name: 'Combined PI, PL, EL',
  },
  {
    id: 496,
    code: '991',
    name: 'Prof Indty Expert Witness',
  },
  {
    id: 497,
    code: '101',
    name: 'VAT',
  },
  {
    id: 498,
    code: '102',
    name: 'Fee',
  },
  {
    id: 499,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 500,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 501,
    code: '107',
    name: 'Mobility Claims',
  },
  {
    id: 502,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 503,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 504,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 505,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 506,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 507,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 508,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 509,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 510,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 511,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 512,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 513,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 514,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 515,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 516,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 517,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 518,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 519,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 520,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 521,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 522,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 523,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 524,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 525,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 526,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 527,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 528,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 529,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 530,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 531,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 532,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 533,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 534,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 535,
    code: '303',
    name: 'Computers',
  },
  {
    id: 536,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 537,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 538,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 539,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 540,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 541,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 542,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 543,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 544,
    code: '320',
    name: 'Money',
  },
  {
    id: 545,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 546,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 547,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 548,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 549,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 550,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 551,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 552,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 553,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 554,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 555,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 556,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 557,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 558,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 559,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 560,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 561,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 562,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 563,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 564,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 565,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 566,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 567,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 568,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 569,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 570,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 571,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 572,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 573,
    code: '410',
    name: 'Crime',
  },
  {
    id: 574,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 575,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 576,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 577,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 578,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 579,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 580,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 581,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 582,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 583,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 584,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 585,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 586,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 587,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 588,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 589,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 590,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 591,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 592,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 593,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 594,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 595,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 596,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 597,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 598,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 599,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 600,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 601,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 602,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 603,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 604,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 605,
    code: '944',
    name: 'Mobility',
  },
  {
    id: 606,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 607,
    code: '102',
    name: 'Fee',
  },
  {
    id: 608,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 609,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 610,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 611,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 612,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 613,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 614,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 615,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 616,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 617,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 618,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 619,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 620,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 621,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 622,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 623,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 624,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 625,
    code: '168',
    name: 'Prof Indty Will Writers',
  },
  {
    id: 626,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 627,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 628,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 629,
    code: '179',
    name: 'Prof Indty Accountants ACCA',
  },
  {
    id: 630,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 631,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 632,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 633,
    code: '186',
    name: 'Prof Indty Mortgage Advisors',
  },
  {
    id: 634,
    code: '234',
    name: 'PI Recruitment Consultants',
  },
  {
    id: 635,
    code: '249',
    name: 'Prof Indty Loss Adjusters',
  },
  {
    id: 636,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 637,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 638,
    code: '282',
    name: 'Prof Indty Advertising Media',
  },
  {
    id: 639,
    code: '284',
    name: 'PI Insolvency Practitioners',
  },
  {
    id: 640,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 641,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 642,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 643,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 644,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 645,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 646,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 647,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 648,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 649,
    code: '839',
    name: 'Combined PI, PL, EL',
  },
  {
    id: 650,
    code: '991',
    name: 'Prof Indty Expert Witness',
  },
  {
    id: 651,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 652,
    code: '800',
    name: 'Warranty & Indemnity',
  },
  {
    id: 653,
    code: 'CRIN',
    name: 'Contingent Risks Insurance',
  },
  {
    id: 654,
    code: 'TIIN',
    name: 'Title Insurance',
  },
  {
    id: 655,
    code: 'TLIN',
    name: 'Tax Liability Insurance',
  },
  {
    id: 656,
    code: 'WGU',
    name: 'WARRANTY GUARANTEE',
  },
  {
    id: 657,
    code: '227',
    name: 'Direct and Facultative Binders',
  },
  {
    id: 658,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 659,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 660,
    code: '318',
    name: 'Exhibition',
  },
  {
    id: 661,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 662,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 663,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 664,
    code: '812',
    name: 'Specie',
  },
  {
    id: 665,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 666,
    code: 'ACR',
    name: 'Armored Car Transit Risks',
  },
  {
    id: 667,
    code: 'ACV',
    name: 'ATM Coverage',
  },
  {
    id: 668,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 669,
    code: 'COR',
    name: 'Courier Risks',
  },
  {
    id: 670,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 671,
    code: 'JFF',
    name: 'Jewellery Furs & Fine Arts',
  },
  {
    id: 672,
    code: 'PMAR',
    name: 'Precious Metals All Risks Of Physical Loss Or Damage',
  },
  {
    id: 673,
    code: 'SPES',
    name: 'General Specie',
  },
  {
    id: 674,
    code: '102',
    name: 'Fee',
  },
  {
    id: 675,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 676,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 677,
    code: '126',
    name: 'PI Solicitors Excess',
  },
  {
    id: 678,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 679,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 680,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 681,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 682,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 683,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 684,
    code: '284',
    name: 'PI Insolvency Practitioners',
  },
  {
    id: 685,
    code: '410',
    name: 'Crime',
  },
  {
    id: 686,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 687,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 688,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 689,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 690,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 691,
    code: '404',
    name: 'Bonds',
  },
  {
    id: 692,
    code: '410',
    name: 'Crime',
  },
  {
    id: 693,
    code: 'BBB',
    name: 'Bankers Blanket Bond',
  },
  {
    id: 694,
    code: 'BRO',
    name: 'BROKERS BLANKET INSURANCE',
  },
  {
    id: 695,
    code: 'CIV',
    name: 'Civil Liability Insurance',
  },
  {
    id: 696,
    code: 'MIP',
    name: 'Mortgage Impairment Protection',
  },
  {
    id: 697,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 698,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 699,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 700,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 701,
    code: '410',
    name: 'Crime',
  },
  {
    id: 702,
    code: 'LSML',
    name: 'Liability SML',
  },
  {
    id: 703,
    code: 'MIP',
    name: 'Mortgage Impairment Protection',
  },
  {
    id: 704,
    code: '101',
    name: 'VAT',
  },
  {
    id: 705,
    code: '102',
    name: 'Fee',
  },
  {
    id: 706,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 707,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 708,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 709,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 710,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 711,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 712,
    code: '170',
    name: 'Dental Malpractice',
  },
  {
    id: 713,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 714,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 715,
    code: '271',
    name: 'Healthcare Advisory Services Fee',
  },
  {
    id: 716,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 717,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 718,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 719,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 720,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 721,
    code: '410',
    name: 'Crime',
  },
  {
    id: 722,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 723,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 724,
    code: '101',
    name: 'VAT',
  },
  {
    id: 725,
    code: '102',
    name: 'Fee',
  },
  {
    id: 726,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 727,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 728,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 729,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 730,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 731,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 732,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 733,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 734,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 735,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 736,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 737,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 738,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 739,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 740,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 741,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 742,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 743,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 744,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 745,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 746,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 747,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 748,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 749,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 750,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 751,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 752,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 753,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 754,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 755,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 756,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 757,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 758,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 759,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 760,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 761,
    code: '303',
    name: 'Computers',
  },
  {
    id: 762,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 763,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 764,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 765,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 766,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 767,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 768,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 769,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 770,
    code: '320',
    name: 'Money',
  },
  {
    id: 771,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 772,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 773,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 774,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 775,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 776,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 777,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 778,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 779,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 780,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 781,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 782,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 783,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 784,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 785,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 786,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 787,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 788,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 789,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 790,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 791,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 792,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 793,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 794,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 795,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 796,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 797,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 798,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 799,
    code: '410',
    name: 'Crime',
  },
  {
    id: 800,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 801,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 802,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 803,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 804,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 805,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 806,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 807,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 808,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 809,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 810,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 811,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 812,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 813,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 814,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 815,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 816,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 817,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 818,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 819,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 820,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 821,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 822,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 823,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 824,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 825,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 826,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 827,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 828,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 829,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 830,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 831,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 832,
    code: '005',
    name: 'Property Damage',
  },
  {
    id: 833,
    code: '012',
    name: 'Erection All Risks',
  },
  {
    id: 834,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 835,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 836,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 837,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 838,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 839,
    code: 'FAC',
    name: 'Property FAC',
  },
  {
    id: 840,
    code: 'FIR',
    name: 'FIRE & ALLIED PERILS',
  },
  {
    id: 841,
    code: '102',
    name: 'Fee',
  },
  {
    id: 842,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 843,
    code: '404',
    name: 'Bonds',
  },
  {
    id: 844,
    code: 'CCP',
    name: 'Comprehensive Contractors Plant Political',
  },
  {
    id: 845,
    code: 'CEN',
    name: 'Confiscation Expropriation Nationalisation Deprivation',
  },
  {
    id: 846,
    code: 'CFG',
    name: 'Contract Frustration Non Honouring Guarantee or L C',
  },
  {
    id: 847,
    code: 'CFN',
    name: 'Contract Frustration Non Delivery',
  },
  {
    id: 848,
    code: 'CFP',
    name: 'Contract Frustration Non Payment',
  },
  {
    id: 849,
    code: 'CFR',
    name: 'Contract Frustration',
  },
  {
    id: 850,
    code: 'ECM',
    name: 'Confiscation Mobile Assets',
  },
  {
    id: 851,
    code: 'LEN',
    name: 'Lenders Form',
  },
  {
    id: 852,
    code: 'POL',
    name: 'Political Risks Insurance',
  },
  {
    id: 853,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 854,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 855,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 856,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 857,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 858,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 859,
    code: 'ACD',
    name: 'Accidental Death',
  },
  {
    id: 860,
    code: 'CAB',
    name: 'Cancellation Abandonment',
  },
  {
    id: 861,
    code: 'CAW',
    name: 'Contingency Adverse Weather Insurance',
  },
  {
    id: 862,
    code: 'CNA',
    name: 'Cancellation Non Appearance',
  },
  {
    id: 863,
    code: 'CTB',
    name: 'Contractual Bonus',
  },
  {
    id: 864,
    code: 'ERI',
    name: 'A&H Excess Of Loss',
  },
  {
    id: 865,
    code: 'HIO',
    name: 'Hole In One',
  },
  {
    id: 866,
    code: 'LIF',
    name: 'Life',
  },
  {
    id: 867,
    code: 'OVR',
    name: 'Over Redemption',
  },
  {
    id: 868,
    code: 'PZI',
    name: 'Prize Indemnity',
  },
  {
    id: 869,
    code: 'QST',
    name: 'A&H Quota Share',
  },
  {
    id: 870,
    code: '011',
    name: 'Motor Liability',
  },
  {
    id: 871,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 872,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 873,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 874,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 875,
    code: '139',
    name: 'Clinical Trials',
  },
  {
    id: 876,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 877,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 878,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 879,
    code: 'CGL',
    name: 'Commercial General Liability',
  },
  {
    id: 880,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 881,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 882,
    code: 'LIB',
    name: 'Casualty Liability',
  },
  {
    id: 883,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 884,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 885,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 886,
    code: 'LIB',
    name: 'Casualty Liability',
  },
  {
    id: 887,
    code: 'PUN',
    name: 'Punitive Damages',
  },
  {
    id: 888,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 889,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 890,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 891,
    code: 'AHAS',
    name: 'Aircraft Hull & Spares',
  },
  {
    id: 892,
    code: 'AHL',
    name: 'Aircraft Hull & Liability',
  },
  {
    id: 893,
    code: 'AILI',
    name: 'Aircraft Liability',
  },
  {
    id: 894,
    code: 'APH',
    name: 'Aviation Hangar keepers Liability',
  },
  {
    id: 895,
    code: 'API',
    name: 'Aviation Products Liability',
  },
  {
    id: 896,
    code: 'APL',
    name: 'Aviation Premises Liability',
  },
  {
    id: 897,
    code: 'ARE',
    name: 'Airport Liability',
  },
  {
    id: 898,
    code: 'DED',
    name: 'Aviation Hull Deductible',
  },
  {
    id: 899,
    code: 'EWLI',
    name: 'Excess War Liability',
  },
  {
    id: 900,
    code: 'EXC',
    name: 'Aviation Excess Liability',
  },
  {
    id: 901,
    code: 'HUW',
    name: 'Aircraft Hull War',
  },
  {
    id: 902,
    code: 'LOL',
    name: 'Aviation Loss Of Licence',
  },
  {
    id: 903,
    code: 'PAI',
    name: 'Aviation Personal Accident',
  },
  {
    id: 904,
    code: 'PPH',
    name: 'Aviation Premises Products & Hangar keepers Liability',
  },
  {
    id: 905,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 906,
    code: '219',
    name: 'Equipment Physical Damage',
  },
  {
    id: 907,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 908,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 909,
    code: '374',
    name: 'Livestock',
  },
  {
    id: 910,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 911,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 912,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 913,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 914,
    code: '812',
    name: 'Specie',
  },
  {
    id: 915,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 916,
    code: 'APD',
    name: 'Auto Physical Damage',
  },
  {
    id: 917,
    code: 'EXST',
    name: 'Excess Stock',
  },
  {
    id: 918,
    code: 'INSS',
    name: 'Inventory Stock Storage',
  },
  {
    id: 919,
    code: 'SPES',
    name: 'General Specie',
  },
  {
    id: 920,
    code: '004',
    name: 'War',
  },
  {
    id: 921,
    code: '219',
    name: 'Equipment Physical Damage',
  },
  {
    id: 922,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 923,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 924,
    code: '397',
    name: 'Builders All Risks',
  },
  {
    id: 925,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 926,
    code: '486',
    name: 'Marine Port Package',
  },
  {
    id: 927,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 928,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 929,
    code: '812',
    name: 'Specie',
  },
  {
    id: 930,
    code: 'ACD',
    name: 'Accidental Death',
  },
  {
    id: 931,
    code: 'ADP',
    name: 'Marine Additional Perils Mortgagees Interest',
  },
  {
    id: 932,
    code: 'CGW',
    name: 'Cargo War Insurance',
  },
  {
    id: 933,
    code: 'CIT',
    name: 'Charterers Interest TLO',
  },
  {
    id: 934,
    code: 'EQP',
    name: 'Marine Equipment',
  },
  {
    id: 935,
    code: 'IOI',
    name: 'Innocent Owners Insurance',
  },
  {
    id: 936,
    code: 'IVI',
    name: 'Increased Value Insurance',
  },
  {
    id: 937,
    code: 'K&R',
    name: 'Marine Special Contingency',
  },
  {
    id: 938,
    code: 'LHI',
    name: 'Loss Of Hire And Or Interest And Or Earnings',
  },
  {
    id: 939,
    code: 'MAPR',
    name: 'Marine Property',
  },
  {
    id: 940,
    code: 'MCGL',
    name: 'Marine Liability Comprehensive General Liabilities',
  },
  {
    id: 941,
    code: 'MEL',
    name: 'Maritime Employers Liabilities',
  },
  {
    id: 942,
    code: 'MIN',
    name: 'Marine Mortgagees Interest Insurance',
  },
  {
    id: 943,
    code: 'MLEX',
    name: 'Marine Liability Excess',
  },
  {
    id: 944,
    code: 'OPL',
    name: 'Marine Terminal Operators Liability',
  },
  {
    id: 945,
    code: 'POR',
    name: 'Marine Port Risks',
  },
  {
    id: 946,
    code: 'SRL',
    name: 'Shiprepairers Liabilities',
  },
  {
    id: 947,
    code: 'TT3',
    name: 'Terrorism Liability',
  },
  {
    id: 948,
    code: 'UMB',
    name: 'Marine Umbrella Liabilities',
  },
  {
    id: 949,
    code: 'XPI',
    name: 'Protection & Indemnity',
  },
  {
    id: 950,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 951,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 952,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 953,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 954,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 955,
    code: 'ECAR',
    name: 'Energy Construction All Risk',
  },
  {
    id: 956,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 957,
    code: 'ENPR',
    name: 'Energy Property',
  },
  {
    id: 958,
    code: 'EPK',
    name: 'Energy Package',
  },
  {
    id: 959,
    code: 'MEL',
    name: 'Maritime Employers Liabilities',
  },
  {
    id: 960,
    code: 'OEE',
    name: 'Energy Operators Extra Expenses',
  },
  {
    id: 961,
    code: 'TPL',
    name: 'Energy Liability',
  },
  {
    id: 962,
    code: 'XPI',
    name: 'Protection & Indemnity',
  },
  {
    id: 963,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 964,
    code: '193',
    name: 'Reputational Risk Insurance',
  },
  {
    id: 965,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 966,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 967,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 968,
    code: 'PCIN',
    name: 'Premises Contamination Insurance',
  },
  {
    id: 969,
    code: 'PRRG',
    name: 'Product Recall Guarantee',
  },
  {
    id: 970,
    code: '005',
    name: 'Property Damage',
  },
  {
    id: 971,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 972,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 973,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 974,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 975,
    code: 'MAA',
    name: 'Mortgage Protection',
  },
  {
    id: 976,
    code: 'TT3',
    name: 'Terrorism Liability',
  },
  {
    id: 977,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 978,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 979,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 980,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 981,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 982,
    code: 'ECAR',
    name: 'Energy Construction All Risk',
  },
  {
    id: 983,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 984,
    code: 'ENPR',
    name: 'Energy Property',
  },
  {
    id: 985,
    code: 'EPK',
    name: 'Energy Package',
  },
  {
    id: 986,
    code: 'MEL',
    name: 'Maritime Employers Liabilities',
  },
  {
    id: 987,
    code: 'OEE',
    name: 'Energy Operators Extra Expenses',
  },
  {
    id: 988,
    code: 'TPL',
    name: 'Energy Liability',
  },
  {
    id: 989,
    code: 'XPI',
    name: 'Protection & Indemnity',
  },
  {
    id: 990,
    code: '101',
    name: 'VAT',
  },
  {
    id: 991,
    code: '102',
    name: 'Fee',
  },
  {
    id: 992,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 993,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 994,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 995,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 996,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 997,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 998,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 999,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1000,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1001,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1002,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1003,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1004,
    code: '139',
    name: 'Clinical Trials',
  },
  {
    id: 1005,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1006,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1007,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1008,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1009,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 1010,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 1011,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 1012,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1013,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1014,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 1015,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1016,
    code: '202',
    name: 'Motor Commercial Vehicle',
  },
  {
    id: 1017,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1018,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1019,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1020,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1021,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1022,
    code: '212',
    name: 'Minibus',
  },
  {
    id: 1023,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1024,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1025,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1026,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 1027,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1028,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1029,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 1030,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1031,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1032,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1033,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1034,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1035,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1036,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1037,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1038,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1039,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 1040,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1041,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1042,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1043,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1044,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1045,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1046,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1047,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1048,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1049,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1050,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1051,
    code: '358',
    name: 'Woodlands',
  },
  {
    id: 1052,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1053,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1054,
    code: '372',
    name: 'Household',
  },
  {
    id: 1055,
    code: '375',
    name: 'Caravan',
  },
  {
    id: 1056,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1057,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1058,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1059,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 1060,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1061,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1062,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1063,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 1064,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1065,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1066,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1067,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1068,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1069,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1070,
    code: '427',
    name: 'Office Guardian Legal Expenses',
  },
  {
    id: 1071,
    code: '428',
    name: 'Office Guardian',
  },
  {
    id: 1072,
    code: '431',
    name: 'Advertising Agency Indemnity',
  },
  {
    id: 1073,
    code: '433',
    name: 'Crisis Management',
  },
  {
    id: 1074,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1075,
    code: '438',
    name: 'PCGB Private Car',
  },
  {
    id: 1076,
    code: '443',
    name: 'Flood Flash',
  },
  {
    id: 1077,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1078,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1079,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1080,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1081,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1082,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1083,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1084,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1085,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1086,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1087,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1088,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1089,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1090,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1091,
    code: '851',
    name: 'BDC Motor Scheme',
  },
  {
    id: 1092,
    code: '852',
    name: 'BDC Collector',
  },
  {
    id: 1093,
    code: '853',
    name: 'BDC Private Car',
  },
  {
    id: 1094,
    code: '854',
    name: 'BDC Home',
  },
  {
    id: 1095,
    code: '855',
    name: 'BDC Portfolio',
  },
  {
    id: 1096,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1097,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1098,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1099,
    code: '930',
    name: 'Package Policy Surgery',
  },
  {
    id: 1100,
    code: '931',
    name: 'Public House',
  },
  {
    id: 1101,
    code: '938',
    name: 'Package Day Nurseries Playgroups',
  },
  {
    id: 1102,
    code: '947',
    name: 'Package Policy Nursing Rest Homes',
  },
  {
    id: 1103,
    code: '992',
    name: 'PCGB Motor Scheme',
  },
  {
    id: 1104,
    code: '993',
    name: 'PCGB Home',
  },
  {
    id: 1105,
    code: '994',
    name: 'PCGB Collector',
  },
  {
    id: 1106,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1107,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1108,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1109,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1110,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1111,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1112,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1113,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1114,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1115,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1116,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1117,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1118,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1119,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1120,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1121,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 1122,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1123,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1124,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1125,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1126,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1127,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1128,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1129,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1130,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1131,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1132,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1133,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1134,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1135,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1136,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1137,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1138,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1139,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 1140,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1141,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 1142,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1143,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1144,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1145,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1146,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1147,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1148,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1149,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1150,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 1151,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1152,
    code: '320',
    name: 'Money',
  },
  {
    id: 1153,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1154,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1155,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 1156,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1157,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 1158,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1159,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1160,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 1161,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1162,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1163,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1164,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 1165,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1166,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1167,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 1168,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 1169,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1170,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1171,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 1172,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1173,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1174,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1175,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1176,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1177,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1178,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 1179,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1180,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1181,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1182,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 1183,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1184,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1185,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1186,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 1187,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1188,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 1189,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1190,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1191,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 1192,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1193,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1194,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1195,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1196,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 1197,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1198,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1199,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1200,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1201,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1202,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1203,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1204,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 1205,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1206,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 1207,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1208,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1209,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 1210,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1211,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 1212,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 1213,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 1214,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1215,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1216,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1217,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1218,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1219,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1220,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1221,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1222,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1223,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1224,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 1225,
    code: '126',
    name: 'PI Solicitors Excess',
  },
  {
    id: 1226,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1227,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1228,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1229,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 1230,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 1231,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 1232,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1233,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 1234,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1235,
    code: '179',
    name: 'Prof Indty Accountants ACCA',
  },
  {
    id: 1236,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 1237,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1238,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 1239,
    code: '202',
    name: 'Motor Commercial Vehicle',
  },
  {
    id: 1240,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1241,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1242,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1243,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1244,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1245,
    code: '211',
    name: 'Motor Contingency',
  },
  {
    id: 1246,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1247,
    code: '252',
    name: 'Motorcycle',
  },
  {
    id: 1248,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1249,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1250,
    code: '279',
    name: 'Brokers Ireland PI Scheme',
  },
  {
    id: 1251,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 1252,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1253,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1254,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1255,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1256,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1257,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1258,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1259,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1260,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1261,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1262,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1263,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1264,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1265,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1266,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1267,
    code: '343',
    name: 'Engineering Lifting Gear',
  },
  {
    id: 1268,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 1269,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 1270,
    code: '372',
    name: 'Household',
  },
  {
    id: 1271,
    code: '388',
    name: 'Stevedores Liability',
  },
  {
    id: 1272,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1273,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 1274,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1275,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1276,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 1277,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 1278,
    code: '404',
    name: 'Bonds',
  },
  {
    id: 1279,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1280,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1281,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 1282,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1283,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1284,
    code: '458',
    name: 'Private Medical Expenses',
  },
  {
    id: 1285,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1286,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1287,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1288,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1289,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1290,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1291,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1292,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 1293,
    code: '559',
    name: 'Motor Haulage ADF&T',
  },
  {
    id: 1294,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1295,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1296,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1297,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1298,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1299,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1300,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1301,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1302,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1303,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1304,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1305,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1306,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1307,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1308,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1309,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1310,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1311,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 1312,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1313,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1314,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1315,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1316,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1317,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1318,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1319,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1320,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1321,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1322,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1323,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1324,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1325,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1326,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1327,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1328,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1329,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 1330,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1331,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 1332,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1333,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1334,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1335,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1336,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1337,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1338,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1339,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1340,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 1341,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1342,
    code: '320',
    name: 'Money',
  },
  {
    id: 1343,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1344,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1345,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 1346,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1347,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 1348,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1349,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1350,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 1351,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1352,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1353,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1354,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 1355,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1356,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1357,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 1358,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 1359,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1360,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1361,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 1362,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1363,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1364,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1365,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1366,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1367,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1368,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 1369,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1370,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1371,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1372,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 1373,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1374,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1375,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1376,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 1377,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1378,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 1379,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1380,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1381,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 1382,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1383,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1384,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1385,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1386,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 1387,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1388,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1389,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1390,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1391,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1392,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1393,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1394,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 1395,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1396,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 1397,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1398,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1399,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 1400,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1401,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 1402,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 1403,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 1404,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1405,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1406,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1407,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1408,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1409,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1410,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1411,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1412,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1413,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1414,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1415,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1416,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1417,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1418,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1419,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 1420,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1421,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1422,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1423,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1424,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1425,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1426,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1427,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1428,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1429,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1430,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1431,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1432,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1433,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1434,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1435,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1436,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1437,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 1438,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1439,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1440,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1441,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1442,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1443,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1444,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1445,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1446,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1447,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 1448,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1449,
    code: '320',
    name: 'Money',
  },
  {
    id: 1450,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1451,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1452,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 1453,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1454,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 1455,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1456,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1457,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 1458,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1459,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1460,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1461,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 1462,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1463,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1464,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 1465,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 1466,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1467,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1468,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 1469,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1470,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1471,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1472,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1473,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1474,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1475,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 1476,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1477,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1478,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1479,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 1480,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1481,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1482,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1483,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 1484,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1485,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 1486,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1487,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1488,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 1489,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1490,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1491,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1492,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1493,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 1494,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1495,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1496,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1497,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1498,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1499,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1500,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 1501,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1502,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 1503,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1504,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1505,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 1506,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1507,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 1508,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 1509,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 1510,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1511,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1512,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1513,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1514,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1515,
    code: '278',
    name: 'Directors & Officers PI & Crime',
  },
  {
    id: 1516,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1517,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1518,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1519,
    code: '476',
    name: 'Reiseforsikring – Firma',
  },
  {
    id: 1520,
    code: '477',
    name: 'Kontorforsikring',
  },
  {
    id: 1521,
    code: '478',
    name: 'Fritidsulykkeforsikring',
  },
  {
    id: 1522,
    code: '479',
    name: 'Yrkesskadeforsikring',
  },
  {
    id: 1523,
    code: '480',
    name: 'Familieulykkeforsikring',
  },
  {
    id: 1524,
    code: '481',
    name: 'Reiseforsikring – Privat',
  },
  {
    id: 1525,
    code: '482',
    name: 'Sykeavbruddsforsikring',
  },
  {
    id: 1526,
    code: '483',
    name: 'Gruppelivsforsikring',
  },
  {
    id: 1527,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1528,
    code: '750',
    name: 'PI GL Cyber',
  },
  {
    id: 1529,
    code: '760',
    name: 'AllRisk spesialfors stedbunde',
  },
  {
    id: 1530,
    code: '761',
    name: 'Maskinforsikring Minibank',
  },
  {
    id: 1531,
    code: '762',
    name: 'Motorvogn',
  },
  {
    id: 1532,
    code: '766',
    name: 'Pengetransport',
  },
  {
    id: 1533,
    code: '767',
    name: 'Kriminalitet',
  },
  {
    id: 1534,
    code: '768',
    name: 'Styreansvar',
  },
  {
    id: 1535,
    code: '769',
    name: 'Dropsafe nattsafe',
  },
  {
    id: 1536,
    code: '770',
    name: 'Gruppeliv',
  },
  {
    id: 1537,
    code: '771',
    name: 'Nøkkelmann',
  },
  {
    id: 1538,
    code: '772',
    name: 'Kombinert bedriftsforsikring',
  },
  {
    id: 1539,
    code: '773',
    name: 'Yrkesskade',
  },
  {
    id: 1540,
    code: '774',
    name: 'Integrert Personalforsikring',
  },
  {
    id: 1541,
    code: '775',
    name: 'Profesjonsansvar',
  },
  {
    id: 1542,
    code: '776',
    name: 'Komb Prof ansvar Kriminalite',
  },
  {
    id: 1543,
    code: '777',
    name: 'Ting Eiendomsforsikring',
  },
  {
    id: 1544,
    code: '779',
    name: 'Sykeavbrudd',
  },
  {
    id: 1545,
    code: '780',
    name: 'Tredjemannsansvar',
  },
  {
    id: 1546,
    code: '786',
    name: 'Sykeavbruddsforsikring',
  },
  {
    id: 1547,
    code: '787',
    name: 'Gruppeliv med Uf°rekapital',
  },
  {
    id: 1548,
    code: '788',
    name: 'Kidnapping og l°sepenger',
  },
  {
    id: 1549,
    code: '789',
    name: 'PE ansvarsforsikring',
  },
  {
    id: 1550,
    code: '792',
    name: 'Verdigjenstand',
  },
  {
    id: 1551,
    code: '793',
    name: 'Arbeidsmaskin',
  },
  {
    id: 1552,
    code: '797',
    name: 'Betalingsforsikring',
  },
  {
    id: 1553,
    code: '798',
    name: 'Reiseforsikring',
  },
  {
    id: 1554,
    code: '799',
    name: 'Ulykkesforsikring',
  },
  {
    id: 1555,
    code: '811',
    name: 'Behandlingsforsikring – Firma',
  },
  {
    id: 1556,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1557,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1558,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1559,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1560,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1561,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1562,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1563,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1564,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1565,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1566,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1567,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1568,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1569,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1570,
    code: '139',
    name: 'Clinical Trials',
  },
  {
    id: 1571,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1572,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1573,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1574,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1575,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 1576,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 1577,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 1578,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1579,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1580,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 1581,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1582,
    code: '202',
    name: 'Motor Commercial Vehicle',
  },
  {
    id: 1583,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1584,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1585,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1586,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1587,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1588,
    code: '212',
    name: 'Minibus',
  },
  {
    id: 1589,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1590,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1591,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1592,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 1593,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1594,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1595,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 1596,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1597,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1598,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1599,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1600,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1601,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1602,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1603,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1604,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1605,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 1606,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1607,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1608,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1609,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1610,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1611,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1612,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1613,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1614,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1615,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1616,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1617,
    code: '358',
    name: 'Woodlands',
  },
  {
    id: 1618,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1619,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1620,
    code: '372',
    name: 'Household',
  },
  {
    id: 1621,
    code: '375',
    name: 'Caravan',
  },
  {
    id: 1622,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1623,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1624,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1625,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 1626,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1627,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1628,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1629,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 1630,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1631,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1632,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1633,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1634,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1635,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1636,
    code: '427',
    name: 'Office Guardian Legal Expenses',
  },
  {
    id: 1637,
    code: '428',
    name: 'Office Guardian',
  },
  {
    id: 1638,
    code: '431',
    name: 'Advertising Agency Indemnity',
  },
  {
    id: 1639,
    code: '433',
    name: 'Crisis Management',
  },
  {
    id: 1640,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1641,
    code: '438',
    name: 'PCGB Private Car',
  },
  {
    id: 1642,
    code: '443',
    name: 'Flood Flash',
  },
  {
    id: 1643,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1644,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1645,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1646,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1647,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1648,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1649,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1650,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1651,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1652,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1653,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1654,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1655,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1656,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1657,
    code: '851',
    name: 'BDC Motor Scheme',
  },
  {
    id: 1658,
    code: '852',
    name: 'BDC Collector',
  },
  {
    id: 1659,
    code: '853',
    name: 'BDC Private Car',
  },
  {
    id: 1660,
    code: '854',
    name: 'BDC Home',
  },
  {
    id: 1661,
    code: '855',
    name: 'BDC Portfolio',
  },
  {
    id: 1662,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1663,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1664,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1665,
    code: '930',
    name: 'Package Policy Surgery',
  },
  {
    id: 1666,
    code: '931',
    name: 'Public House',
  },
  {
    id: 1667,
    code: '938',
    name: 'Package Day Nurseries Playgroups',
  },
  {
    id: 1668,
    code: '947',
    name: 'Package Policy Nursing Rest Homes',
  },
  {
    id: 1669,
    code: '992',
    name: 'PCGB Motor Scheme',
  },
  {
    id: 1670,
    code: '993',
    name: 'PCGB Home',
  },
  {
    id: 1671,
    code: '994',
    name: 'PCGB Collector',
  },
  {
    id: 1672,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1673,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1674,
    code: '262',
    name: 'Group Income Protection',
  },
  {
    id: 1675,
    code: '445',
    name: 'Technology (Benefits)',
  },
  {
    id: 1676,
    code: '446',
    name: 'Communications (Benefits)',
  },
  {
    id: 1677,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1678,
    code: '598',
    name: 'Non-Advice Pensions Consultancy',
  },
  {
    id: 1679,
    code: '599',
    name: 'Clinical Advisory Services',
  },
  {
    id: 1680,
    code: '600',
    name: 'Retail Discounts',
  },
  {
    id: 1681,
    code: '602',
    name: 'Dental',
  },
  {
    id: 1682,
    code: '625',
    name: 'Private Medical Insurance',
  },
  {
    id: 1683,
    code: '640',
    name: 'Group Life Assurance',
  },
  {
    id: 1684,
    code: '652',
    name: 'Key Person Insurance',
  },
  {
    id: 1685,
    code: '699',
    name: 'Group Critical Illness',
  },
  {
    id: 1686,
    code: '715',
    name: 'International Private Medical',
  },
  {
    id: 1687,
    code: '720',
    name: 'Employee Assistance Programme',
  },
  {
    id: 1688,
    code: '721',
    name: 'Cashplan',
  },
  {
    id: 1689,
    code: '722',
    name: 'Health Screen',
  },
  {
    id: 1690,
    code: '723',
    name: 'Project Consulting',
  },
  {
    id: 1691,
    code: '725',
    name: 'Project Due Diligence',
  },
  {
    id: 1692,
    code: '726',
    name: 'Inbound Payaway',
  },
  {
    id: 1693,
    code: '727',
    name: 'Travel Leisure (Benefits)',
  },
  {
    id: 1694,
    code: '728',
    name: 'Travel Business (Benefits)',
  },
  {
    id: 1695,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1696,
    code: '262',
    name: 'Group Income Protection',
  },
  {
    id: 1697,
    code: '445',
    name: 'Technology (Benefits)',
  },
  {
    id: 1698,
    code: '446',
    name: 'Communications (Benefits)',
  },
  {
    id: 1699,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1700,
    code: '598',
    name: 'Non-Advice Pensions Consultancy',
  },
  {
    id: 1701,
    code: '599',
    name: 'Clinical Advisory Services',
  },
  {
    id: 1702,
    code: '600',
    name: 'Retail Discounts',
  },
  {
    id: 1703,
    code: '602',
    name: 'Dental',
  },
  {
    id: 1704,
    code: '625',
    name: 'Private Medical Insurance',
  },
  {
    id: 1705,
    code: '640',
    name: 'Group Life Assurance',
  },
  {
    id: 1706,
    code: '652',
    name: 'Key Person Insurance',
  },
  {
    id: 1707,
    code: '699',
    name: 'Group Critical Illness',
  },
  {
    id: 1708,
    code: '715',
    name: 'International Private Medical',
  },
  {
    id: 1709,
    code: '720',
    name: 'Employee Assistance Programme',
  },
  {
    id: 1710,
    code: '721',
    name: 'Cashplan',
  },
  {
    id: 1711,
    code: '722',
    name: 'Health Screen',
  },
  {
    id: 1712,
    code: '723',
    name: 'Project Consulting',
  },
  {
    id: 1713,
    code: '725',
    name: 'Project Due Diligence',
  },
  {
    id: 1714,
    code: '726',
    name: 'Inbound Payaway',
  },
  {
    id: 1715,
    code: '727',
    name: 'Travel Leisure (Benefits)',
  },
  {
    id: 1716,
    code: '728',
    name: 'Travel Business (Benefits)',
  },
  {
    id: 1717,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1718,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1719,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1720,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1721,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1722,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1723,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1724,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1725,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1726,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1727,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1728,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1729,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1730,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1731,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1732,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 1733,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1734,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1735,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1736,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1737,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1738,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1739,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1740,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1741,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1742,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1743,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1744,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1745,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1746,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1747,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1748,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1749,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1750,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 1751,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1752,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 1753,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1754,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1755,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1756,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1757,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1758,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1759,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1760,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1761,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 1762,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1763,
    code: '320',
    name: 'Money',
  },
  {
    id: 1764,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1765,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1766,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 1767,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1768,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 1769,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1770,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1771,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 1772,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1773,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1774,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1775,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 1776,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1777,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1778,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 1779,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 1780,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1781,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1782,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 1783,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1784,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1785,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1786,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1787,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1788,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1789,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 1790,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1791,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1792,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1793,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 1794,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1795,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1796,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1797,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 1798,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1799,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 1800,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1801,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1802,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 1803,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1804,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1805,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1806,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1807,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 1808,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1809,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1810,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1811,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1812,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1813,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1814,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1815,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 1816,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1817,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 1818,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1819,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1820,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 1821,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1822,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 1823,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 1824,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 1825,
    code: '101',
    name: 'VAT',
  },
  {
    id: 1826,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1827,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1828,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 1829,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1830,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1831,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1832,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1833,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1834,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 1835,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1836,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1837,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1838,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 1839,
    code: '139',
    name: 'Clinical Trials',
  },
  {
    id: 1840,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 1841,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 1842,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1843,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1844,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 1845,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 1846,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 1847,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1848,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1849,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 1850,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1851,
    code: '202',
    name: 'Motor Commercial Vehicle',
  },
  {
    id: 1852,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1853,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1854,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1855,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1856,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1857,
    code: '212',
    name: 'Minibus',
  },
  {
    id: 1858,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 1859,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 1860,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1861,
    code: '258',
    name: 'Motor Breakdown Cover',
  },
  {
    id: 1862,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1863,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1864,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 1865,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1866,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1867,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1868,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1869,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 1870,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 1871,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 1872,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 1873,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 1874,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 1875,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1876,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 1877,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 1878,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 1879,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 1880,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 1881,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 1882,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 1883,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 1884,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 1885,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 1886,
    code: '358',
    name: 'Woodlands',
  },
  {
    id: 1887,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 1888,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 1889,
    code: '372',
    name: 'Household',
  },
  {
    id: 1890,
    code: '375',
    name: 'Caravan',
  },
  {
    id: 1891,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 1892,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 1893,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 1894,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 1895,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 1896,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 1897,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 1898,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 1899,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 1900,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 1901,
    code: '410',
    name: 'Crime',
  },
  {
    id: 1902,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 1903,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 1904,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 1905,
    code: '427',
    name: 'Office Guardian Legal Expenses',
  },
  {
    id: 1906,
    code: '428',
    name: 'Office Guardian',
  },
  {
    id: 1907,
    code: '431',
    name: 'Advertising Agency Indemnity',
  },
  {
    id: 1908,
    code: '433',
    name: 'Crisis Management',
  },
  {
    id: 1909,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 1910,
    code: '438',
    name: 'PCGB Private Car',
  },
  {
    id: 1911,
    code: '443',
    name: 'Flood Flash',
  },
  {
    id: 1912,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1913,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 1914,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 1915,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 1916,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 1917,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 1918,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 1919,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 1920,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 1921,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 1922,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 1923,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 1924,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 1925,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 1926,
    code: '851',
    name: 'BDC Motor Scheme',
  },
  {
    id: 1927,
    code: '852',
    name: 'BDC Collector',
  },
  {
    id: 1928,
    code: '853',
    name: 'BDC Private Car',
  },
  {
    id: 1929,
    code: '854',
    name: 'BDC Home',
  },
  {
    id: 1930,
    code: '855',
    name: 'BDC Portfolio',
  },
  {
    id: 1931,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 1932,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 1933,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 1934,
    code: '930',
    name: 'Package Policy Surgery',
  },
  {
    id: 1935,
    code: '931',
    name: 'Public House',
  },
  {
    id: 1936,
    code: '938',
    name: 'Package Day Nurseries Playgroups',
  },
  {
    id: 1937,
    code: '947',
    name: 'Package Policy Nursing Rest Homes',
  },
  {
    id: 1938,
    code: '992',
    name: 'PCGB Motor Scheme',
  },
  {
    id: 1939,
    code: '993',
    name: 'PCGB Home',
  },
  {
    id: 1940,
    code: '994',
    name: 'PCGB Collector',
  },
  {
    id: 1941,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1942,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1943,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1944,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1945,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1946,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1947,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 1948,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1949,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1950,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 1951,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 1952,
    code: '441',
    name: 'Pharmacists',
  },
  {
    id: 1953,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 1954,
    code: '625',
    name: 'Private Medical Insurance',
  },
  {
    id: 1955,
    code: '722',
    name: 'Health Screen',
  },
  {
    id: 1956,
    code: '897',
    name: 'PREMIUM',
  },
  {
    id: 1957,
    code: '102',
    name: 'Fee',
  },
  {
    id: 1958,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 1959,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 1960,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 1961,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 1962,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 1963,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 1964,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 1965,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 1966,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 1967,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 1968,
    code: '126',
    name: 'PI Solicitors Excess',
  },
  {
    id: 1969,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 1970,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 1971,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 1972,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 1973,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 1974,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 1975,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 1976,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 1977,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 1978,
    code: '179',
    name: 'Prof Indty Accountants ACCA',
  },
  {
    id: 1979,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 1980,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 1981,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 1982,
    code: '202',
    name: 'Motor Commercial Vehicle',
  },
  {
    id: 1983,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 1984,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 1985,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 1986,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 1987,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 1988,
    code: '211',
    name: 'Motor Contingency',
  },
  {
    id: 1989,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 1990,
    code: '252',
    name: 'Motorcycle',
  },
  {
    id: 1991,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 1992,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 1993,
    code: '279',
    name: 'Brokers Ireland PI Scheme',
  },
  {
    id: 1994,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 1995,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 1996,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 1997,
    code: '303',
    name: 'Computers',
  },
  {
    id: 1998,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 1999,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 2000,
    code: '307',
    name: 'Terrorism',
  },
  {
    id: 2001,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 2002,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 2003,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 2004,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 2005,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 2006,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 2007,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 2008,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 2009,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 2010,
    code: '343',
    name: 'Engineering Lifting Gear',
  },
  {
    id: 2011,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 2012,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 2013,
    code: '372',
    name: 'Household',
  },
  {
    id: 2014,
    code: '388',
    name: 'Stevedores Liability',
  },
  {
    id: 2015,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 2016,
    code: '392',
    name: 'Package Policy Restaurants',
  },
  {
    id: 2017,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 2018,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2019,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 2020,
    code: '403',
    name: 'Trade Credit Insurance',
  },
  {
    id: 2021,
    code: '404',
    name: 'Bonds',
  },
  {
    id: 2022,
    code: '410',
    name: 'Crime',
  },
  {
    id: 2023,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 2024,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 2025,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 2026,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 2027,
    code: '458',
    name: 'Private Medical Expenses',
  },
  {
    id: 2028,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 2029,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 2030,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 2031,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 2032,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 2033,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 2034,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 2035,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 2036,
    code: '559',
    name: 'Motor Haulage ADF&T',
  },
  {
    id: 2037,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 2038,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 2039,
    code: '262',
    name: 'Group Income Protection',
  },
  {
    id: 2040,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 2041,
    code: '599',
    name: 'Clinical Advisory Services',
  },
  {
    id: 2042,
    code: '602',
    name: 'Dental',
  },
  {
    id: 2043,
    code: '625',
    name: 'Private Medical Insurance',
  },
  {
    id: 2044,
    code: '640',
    name: 'Group Life Assurance',
  },
  {
    id: 2045,
    code: '652',
    name: 'Key Person Insurance',
  },
  {
    id: 2046,
    code: '699',
    name: 'Group Critical Illness',
  },
  {
    id: 2047,
    code: '715',
    name: 'International Private Medical',
  },
  {
    id: 2048,
    code: '720',
    name: 'Employee Assistance Programme',
  },
  {
    id: 2049,
    code: '721',
    name: 'Cashplan',
  },
  {
    id: 2050,
    code: '722',
    name: 'Health Screen',
  },
  {
    id: 2051,
    code: '727',
    name: 'Travel Leisure (Benefits)',
  },
  {
    id: 2052,
    code: '728',
    name: 'Travel Business (Benefits)',
  },
  {
    id: 2053,
    code: '111',
    name: 'Employers Liability',
  },
  {
    id: 2054,
    code: '112',
    name: 'Public & Products Liability',
  },
  {
    id: 2055,
    code: '113',
    name: 'Public Liability',
  },
  {
    id: 2056,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 2057,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2058,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 2059,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 2060,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 2061,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2062,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 2063,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 2064,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 2065,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 2066,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 2067,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 2068,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 2069,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 2070,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2071,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2072,
    code: '203',
    name: 'Motor Fleet',
  },
  {
    id: 2073,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 2074,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 2075,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 2076,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 2077,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 2078,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 2079,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 2080,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 2081,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 2082,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 2083,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 2084,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 2085,
    code: '303',
    name: 'Computers',
  },
  {
    id: 2086,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 2087,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 2089,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 2090,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 2091,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 2092,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 2093,
    code: '316',
    name: 'Contractors All Risks',
  },
  {
    id: 2095,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 2096,
    code: '322',
    name: 'Engineering Hired in Plant',
  },
  {
    id: 2097,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 2098,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 2099,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 2100,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 2101,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 2102,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 2103,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 2104,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 2105,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 2106,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 2107,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 2108,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 2109,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 2110,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 2111,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 2112,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 2113,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 2114,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 2115,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 2116,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 2117,
    code: '393',
    name: 'Contractors Plant and Equipment',
  },
  {
    id: 2118,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 2119,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2120,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 2121,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 2122,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 2123,
    code: '410',
    name: 'Crime',
  },
  {
    id: 2124,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 2125,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 2126,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 2127,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 2128,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 2129,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 2130,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 2131,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 2132,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 2133,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 2134,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 2135,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 2136,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 2137,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 2138,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 2139,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 2140,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 2141,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 2142,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 2143,
    code: '530',
    name: 'Marine Hull',
  },
  {
    id: 2144,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 2145,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 2146,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 2147,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 2148,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 2149,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 2150,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 2151,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 2152,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 2153,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 2154,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 2155,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 2156,
    code: '812',
    name: 'Behandlingsforsikring - Individuell',
  },
  {
    id: 2157,
    code: '452',
    name: 'Group Personal Accident',
  },
  {
    id: 2158,
    code: '477',
    name: 'Office',
  },
  {
    id: 2159,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2160,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 2161,
    code: 'ARE',
    name: 'Airport Liability',
  },
  {
    id: 2162,
    code: 'ARO',
    name: 'All Risks of Physical Loss or Damage incl BI',
  },
  {
    id: 2163,
    code: '315',
    name: 'All Risks Physical Loss or Damage',
  },
  {
    id: 2164,
    code: 'API',
    name: 'Aviation Products Liability',
  },
  {
    id: 2165,
    code: 'MEP',
    name: 'Environmental PI',
  },
  {
    id: 2166,
    code: '012',
    name: 'Erection All Risks',
  },
  {
    id: 2167,
    code: 'ELI',
    name: 'Excess Liability',
  },
  {
    id: 2168,
    code: 'GLI',
    name: 'General Liability',
  },
  {
    id: 2169,
    code: '005',
    name: 'Property Damage',
  },
  {
    id: 2170,
    code: 'PUN',
    name: 'Punitive Damages',
  },
  {
    id: 2171,
    code: '004',
    name: 'War',
  },
  {
    id: 2172,
    code: '291',
    name: 'Advertisers Wrap',
  },
  {
    id: 2173,
    code: '344',
    name: 'Agricultural Property',
  },
  {
    id: 2174,
    code: '501',
    name: 'Aircraft Hull',
  },
  {
    id: 2175,
    code: '292',
    name: 'Airside Liability',
  },
  {
    id: 2176,
    code: '334',
    name: 'Asset All Risk',
  },
  {
    id: 2177,
    code: '503',
    name: 'Aviation Liability',
  },
  {
    id: 2178,
    code: '380',
    name: 'Bloodstock',
  },
  {
    id: 2179,
    code: '408',
    name: 'Bond H M Customs & Excise',
  },
  {
    id: 2180,
    code: '417',
    name: 'Bond Performance',
  },
  {
    id: 2181,
    code: '529',
    name: 'Cargo',
  },
  {
    id: 2182,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 2183,
    code: '308',
    name: 'Contingency',
  },
  {
    id: 2184,
    code: '354',
    name: 'Contractors Combined',
  },
  {
    id: 2185,
    code: '336',
    name: 'Contractors Combined Project',
  },
  {
    id: 2186,
    code: '383',
    name: 'Contractors Liability',
  },
  {
    id: 2187,
    code: '857',
    name: 'Contractors Pollution Liability',
  },
  {
    id: 2188,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2189,
    code: '749',
    name: 'Cyber Liability PI Crime Cyber',
  },
  {
    id: 2190,
    code: '321',
    name: 'Deterioration of Stock',
  },
  {
    id: 2191,
    code: '127',
    name: 'Employment Practices Liability',
  },
  {
    id: 2192,
    code: '335',
    name: 'Engineering Combined',
  },
  {
    id: 2193,
    code: '331',
    name: 'Engineering Consequential Loss',
  },
  {
    id: 2194,
    code: '311',
    name: 'Engineering Inspection',
  },
  {
    id: 2195,
    code: '328',
    name: 'Engineering Machinery Breakdown',
  },
  {
    id: 2196,
    code: '361',
    name: 'Engineering Machinery Movement',
  },
  {
    id: 2197,
    code: '340',
    name: 'Engineering Plant All Risks',
  },
  {
    id: 2198,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 2199,
    code: '394',
    name: 'Erection All Risks & TP Liability',
  },
  {
    id: 2200,
    code: '415',
    name: 'Event Insurance',
  },
  {
    id: 2201,
    code: '276',
    name: 'Fee Consultancy',
  },
  {
    id: 2202,
    code: '105',
    name: 'Fee Core Services',
  },
  {
    id: 2203,
    code: '106',
    name: 'Fee Expanded Services',
  },
  {
    id: 2204,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 2205,
    code: '430',
    name: 'Financial Lines Combined',
  },
  {
    id: 2206,
    code: '911',
    name: 'Fine Arts Insurance',
  },
  {
    id: 2207,
    code: '434',
    name: 'Flood Excess',
  },
  {
    id: 2208,
    code: '552',
    name: 'Freight Forwarders Liability',
  },
  {
    id: 2209,
    code: '310',
    name: 'Goods in Transit',
  },
  {
    id: 2210,
    code: '551',
    name: 'Hauliers Liability',
  },
  {
    id: 2211,
    code: '426',
    name: 'Intellectual Property Rights',
  },
  {
    id: 2212,
    code: '364',
    name: 'JCT 651 or equivalent',
  },
  {
    id: 2213,
    code: '324',
    name: 'Jewellers Block Insurance',
  },
  {
    id: 2214,
    code: '359',
    name: 'Latent Defects',
  },
  {
    id: 2215,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2216,
    code: '141',
    name: 'Libel & Slander',
  },
  {
    id: 2217,
    code: '264',
    name: 'Loss Recovery',
  },
  {
    id: 2218,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2219,
    code: '520',
    name: 'Marina Operators Liability',
  },
  {
    id: 2220,
    code: '525',
    name: 'Marine Craft',
  },
  {
    id: 2221,
    code: '523',
    name: 'Marine Hull & Liability',
  },
  {
    id: 2222,
    code: '527',
    name: 'Marine Liability',
  },
  {
    id: 2223,
    code: '326',
    name: 'Material Damage',
  },
  {
    id: 2224,
    code: '333',
    name: 'Material Damage and Business Interruption',
  },
  {
    id: 2225,
    code: '972',
    name: 'Medical Repatriation',
  },
  {
    id: 2226,
    code: '320',
    name: 'Money',
  },
  {
    id: 2227,
    code: '214',
    name: 'Motor Agricultural',
  },
  {
    id: 2228,
    code: '484',
    name: 'Motor Classic Car',
  },
  {
    id: 2229,
    code: '215',
    name: 'Motor Excess Property Damage',
  },
  {
    id: 2230,
    code: '558',
    name: 'Motor Haulage',
  },
  {
    id: 2231,
    code: '943',
    name: 'Motor Legal Expenses',
  },
  {
    id: 2232,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 2233,
    code: '210',
    name: 'Motor Special Types',
  },
  {
    id: 2234,
    code: '204',
    name: 'Motor Traders Combined',
  },
  {
    id: 2235,
    code: '208',
    name: 'Motor Traders Internal Risks',
  },
  {
    id: 2236,
    code: '207',
    name: 'Motor Traders Road Risks',
  },
  {
    id: 2237,
    code: '146',
    name: 'Non Negligence Liability',
  },
  {
    id: 2238,
    code: '902',
    name: 'Package Policy Agricultural',
  },
  {
    id: 2239,
    code: '314',
    name: 'Package Policy Hoteliers',
  },
  {
    id: 2240,
    code: '901',
    name: 'Package Policy Shopkeepers',
  },
  {
    id: 2241,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 2242,
    code: '457',
    name: 'Personal Accident & Sickness',
  },
  {
    id: 2243,
    code: '355',
    name: 'Product Contamination',
  },
  {
    id: 2244,
    code: '119',
    name: 'Products Guarantee',
  },
  {
    id: 2245,
    code: '121',
    name: 'Products Liability',
  },
  {
    id: 2246,
    code: '132',
    name: 'Products Recall',
  },
  {
    id: 2247,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2248,
    code: '306',
    name: 'Property Owners Combined',
  },
  {
    id: 2249,
    code: '155',
    name: 'Property Owners Liability',
  },
  {
    id: 2250,
    code: '414',
    name: 'Restrictive Covenant',
  },
  {
    id: 2251,
    code: '920',
    name: 'RTA Risk',
  },
  {
    id: 2252,
    code: '300',
    name: 'Self-Drive Hire',
  },
  {
    id: 2253,
    code: '407',
    name: 'Special Contingency',
  },
  {
    id: 2254,
    code: '346',
    name: 'Stock Throughput',
  },
  {
    id: 2255,
    code: '904',
    name: 'Tour Operators',
  },
  {
    id: 2256,
    code: '101',
    name: 'VAT',
  },
  {
    id: 2257,
    code: '389',
    name: 'Warehouse Keepers Liability',
  },
  {
    id: 2258,
    code: '385',
    name: 'Yacht & Small Craft',
  },
  {
    id: 2259,
    code: '573',
    name: 'Contractors All Risks and ALOP',
  },
  {
    id: 2260,
    code: '574',
    name: 'Third Party Liability CAR and ALOP',
  },
  {
    id: 2261,
    code: '576',
    name: 'TPL Contractors All Risks',
  },
  {
    id: 2262,
    code: '577',
    name: 'Construction Combined',
  },
  {
    id: 2263,
    code: '578',
    name: 'Third Party Liability and EL',
  },
  {
    id: 2264,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2265,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 2266,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 2267,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 2268,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 2269,
    code: '236',
    name: 'Prof Indty Property Managers',
  },
  {
    id: 2270,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 2271,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 2272,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2273,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2274,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 2275,
    code: '158',
    name: 'Prof Indty Accountants',
  },
  {
    id: 2276,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2277,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 2278,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2279,
    code: '179',
    name: 'Prof Indty Accountants ACCA',
  },
  {
    id: 2280,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2281,
    code: '284',
    name: 'PI Insolvency Practitioners',
  },
  {
    id: 2282,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 2283,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2284,
    code: '428',
    name: 'Office Guardian',
  },
  {
    id: 2285,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 2286,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 2287,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 2288,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2289,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 2290,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2291,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2292,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 2293,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 2294,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 2295,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2296,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 2297,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2298,
    code: '190',
    name: 'Asset Protection',
  },
  {
    id: 2299,
    code: '236',
    name: 'Prof Indty Property Managers',
  },
  {
    id: 2300,
    code: '280',
    name: 'Prof Indty Surveyors RICS',
  },
  {
    id: 2301,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 2302,
    code: '305',
    name: 'Engineering',
  },
  {
    id: 2303,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2304,
    code: '410',
    name: 'Crime',
  },
  {
    id: 2305,
    code: '839',
    name: 'Combined PI',
  },
  {
    id: 2306,
    code: '991',
    name: 'Prof Indty Expert Witness',
  },
  {
    id: 2307,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2308,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 2309,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2310,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2311,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 2312,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 2313,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2314,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2315,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 2316,
    code: '185',
    name: 'PI Lloyds Insurance Brokers',
  },
  {
    id: 2317,
    code: '186',
    name: 'Prof Indty Mortgage Advisors',
  },
  {
    id: 2318,
    code: '191',
    name: 'PI Underwriter Agents & Managers',
  },
  {
    id: 2319,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2320,
    code: '402',
    name: 'Fidelity Guarantee Employee',
  },
  {
    id: 2321,
    code: '410',
    name: 'Crime',
  },
  {
    id: 2331,
    code: '116',
    name: 'Combined Liability',
  },
  {
    id: 2332,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2333,
    code: '123',
    name: 'Pension Fund Trustees Liability',
  },
  {
    id: 2334,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2335,
    code: '125',
    name: 'Prof Indty Solicitors',
  },
  {
    id: 2336,
    code: '151',
    name: 'Charity Trustees Liability',
  },
  {
    id: 2337,
    code: '152',
    name: 'Environmental Impairment Liab',
  },
  {
    id: 2338,
    code: '160',
    name: 'Trustee Liability',
  },
  {
    id: 2339,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2340,
    code: '166',
    name: 'Prof Indty Surveyors',
  },
  {
    id: 2341,
    code: '168',
    name: 'Prof Indty Will Writers',
  },
  {
    id: 2342,
    code: '169',
    name: 'Medical Malpractice',
  },
  {
    id: 2343,
    code: '172',
    name: 'Prof Indty Estate Agent',
  },
  {
    id: 2344,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2345,
    code: '176',
    name: 'PI Design & Construction',
  },
  {
    id: 2346,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 2347,
    code: '183',
    name: 'Cyber Liability',
  },
  {
    id: 2348,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 2349,
    code: '191',
    name: 'PI Underwriter Agents & Managers',
  },
  {
    id: 2350,
    code: '234',
    name: 'PI Recruitment Consultants',
  },
  {
    id: 2351,
    code: '236',
    name: 'Prof Indty Property Managers',
  },
  {
    id: 2352,
    code: '281',
    name: 'Prof Indty IT Professionals',
  },
  {
    id: 2353,
    code: '282',
    name: 'Prof Indty Advertising Media',
  },
  {
    id: 2354,
    code: '284',
    name: 'PI Insolvency Practitioners',
  },
  {
    id: 2355,
    code: '301',
    name: 'Commercial Combined',
  },
  {
    id: 2356,
    code: '303',
    name: 'Computers',
  },
  {
    id: 2357,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2358,
    code: '410',
    name: 'Crime',
  },
  {
    id: 2359,
    code: '425',
    name: 'Legal Indemnity',
  },
  {
    id: 2360,
    code: '436',
    name: 'Package Policy Technology',
  },
  {
    id: 2361,
    code: '456',
    name: 'Personal Accident & Travel',
  },
  {
    id: 2362,
    code: '461',
    name: 'Travel Insurance',
  },
  {
    id: 2363,
    code: '991',
    name: 'Prof Indty Expert Witness',
  },
  {
    id: 2364,
    code: '163',
    name: 'Prof Indty Architects',
  },
  {
    id: 2365,
    code: '164',
    name: 'Prof Indty Insurance Brokers',
  },
  {
    id: 2366,
    code: '165',
    name: 'Prof Indty E&O IFA',
  },
  {
    id: 2367,
    code: '167',
    name: 'Prof Indty Engineers',
  },
  {
    id: 2368,
    code: '175',
    name: 'Professional Indemnity E&O',
  },
  {
    id: 2369,
    code: '181',
    name: 'PI Business Management Consultant',
  },
  {
    id: 2370,
    code: '184',
    name: 'Prof Indty Financial Services',
  },
  {
    id: 2371,
    code: '236',
    name: 'Prof Indty Property Managers',
  },
  {
    id: 2372,
    code: '117',
    name: 'Directors & Officers Liability',
  },
  {
    id: 2373,
    code: '401',
    name: 'Legal Expenses',
  },
  {
    id: 2374,
    code: '124',
    name: 'Management Liabilities Package',
  },
  {
    id: 2375,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2376,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2377,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2378,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2379,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2380,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2381,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2382,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2383,
    code: '493',
    name: 'Political Violence',
  },
  {
    id: 2384,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2385,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2386,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2387,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2388,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2389,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2390,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2391,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2392,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2393,
    code: '812',
    name: 'Specie',
  },
  {
    id: 2394,
    code: 'RPA',
    name: 'RPA',
  },
  {
    id: 2395,
    code: 'RPA',
    name: 'RPA',
  },
  {
    id: 2400,
    code: '477',
    name: 'Office Insurance',
  },
  {
    id: 2978,
    code: '588',
    name: 'EB Package - WC, PA, Illness and Group Life',
  },
  {
    id: 2979,
    code: '584',
    name: 'EB Package - WC, PA, Illness, GL and Pension',
  },
  {
    id: 2980,
    code: '589',
    name: 'Pension Advice',
  },
  {
    id: 2981,
    code: '590',
    name: 'Consulting – (OJ, PA, Illness & Group Life)',
  },
  {
    id: 2982,
    code: '591',
    name: 'Consulting – Pension Advice',
  },
  {
    id: 2983,
    code: '592',
    name: 'Consulting – Financial Well Being (FWB)',
  },
  {
    id: 2984,
    code: '476',
    name: 'Travel Insurance Business',
  },
  {
    id: 2985,
    code: '476_NOR',
    name: 'Reiseforsikring Firma',
  },
  {
    id: 2986,
    code: '480',
    name: 'Family Accident Corporate',
  },
  {
    id: 2987,
    code: '480_NOR',
    name: 'Familieulykkeforsikring',
  },
  {
    id: 2988,
    code: '481',
    name: 'Travel Insurance Private',
  },
  {
    id: 2989,
    code: '483',
    name: 'Group Life & Disability',
  },
  {
    id: 2990,
    code: '483_NOR',
    name: 'Gruppelivsforsikring',
  },
  {
    id: 2991,
    code: '811',
    name: 'Treatment insurance Corporate',
  },
  {
    id: 2992,
    code: '811_NOR',
    name: 'Behandlingsforsikring Firma',
  },
  {
    id: 2993,
    code: '262',
    name: 'Group Income Protection',
  },
  {
    id: 2994,
    code: '454',
    name: 'Personal Accident',
  },
  {
    id: 2995,
    code: '478',
    name: 'Off Work Accident',
  },
  {
    id: 2996,
    code: '478NOR',
    name: 'Fritidsulykkeforsikring',
  },
  {
    id: 2997,
    code: '479',
    name: 'Worker Compensation',
  },
  {
    id: 2998,
    code: '479NOR',
    name: 'Yrkesskadeforsikring',
  },
  {
    id: 2999,
    code: '481NOR',
    name: 'Reiseforsikring Privat',
  },
  {
    id: 3000,
    code: '563',
    name: 'Health Insurance Individual',
  },
  {
    id: 3001,
    code: '701',
    name: 'Disability Lump Sum',
  },
  {
    id: 3002,
    code: '701NOR',
    name: 'Annen sykdom',
  },
  {
    id: 3003,
    code: '710',
    name: 'Child lump sum',
  },
  {
    id: 3004,
    code: '710NOR',
    name: 'Barnetillegg',
  },
  {
    id: 3005,
    code: '716',
    name: 'Defined contribution pension',
  },
  {
    id: 3006,
    code: '716NOR',
    name: 'Innskuddspensjon',
  },
  {
    id: 3007,
    code: '819',
    name: 'Defined benefit pension',
  },
  {
    id: 3008,
    code: '819NOR',
    name: 'Ytelsespensjon',
  },
  {
    id: 3009,
    code: '820',
    name: 'Contractual pension',
  },
  {
    id: 3010,
    code: '820NOR',
    name: 'Avtalefestet pensjon (AFP)',
  },
  {
    id: 3011,
    code: '822',
    name: 'Offshore Contractor Insurance',
  },
  {
    id: 3012,
    code: '822NOR',
    name: 'Offshoredekning',
  },
  {
    id: 3013,
    code: '823',
    name: 'Dependents allowance',
  },
  {
    id: 3014,
    code: '823NOR',
    name: 'Forsørgertillegg',
  },
  {
    id: 3015,
    code: '825',
    name: 'Spouse insurance',
  },
  {
    id: 3016,
    code: '825NOR',
    name: 'Ektefelleforsikring',
  },
  {
    id: 3017,
    code: '826',
    name: 'Expatriate insurance',
  },
  {
    id: 3018,
    code: '826NOR',
    name: 'Forsikring for utestasjonerte',
  },
  {
    id: 3019,
    code: '836',
    name: 'Critical Illness',
  },
  {
    id: 3020,
    code: '836NOR',
    name: 'Kritisk sykdom',
  },
  {
    id: 3021,
    code: '837',
    name: 'Unfunded pension plan',
  },
  {
    id: 3022,
    code: '837NOR',
    name: 'Driftspensjon',
  },
  {
    id: 3023,
    code: '842',
    name: 'Hybrid pension scheme',
  },
  {
    id: 3024,
    code: '842NOR',
    name: 'Hybridpensjon',
  },
  {
    id: 3025,
    code: '843',
    name: 'Group annuity',
  },
  {
    id: 3026,
    code: '843NOR',
    name: 'Kollektiv livrente',
  },
  {
    id: 3027,
    code: '960',
    name: 'AMOC Motor Insurance Scheme',
  },
  {
    id: 3028,
    code: '973',
    name: 'AMOC Collector',
  },
  {
    id: 3029,
    code: '294',
    name: 'AMOC Private Car',
  },
  {
    id: 3030,
    code: '992',
    name: 'PCGB Motor Scheme',
  },
  {
    id: 3031,
    code: '994',
    name: 'PCGB Collector',
  },
  {
    id: 3032,
    code: '438',
    name: 'PCGB Private Car',
  },
  {
    id: 3033,
    code: '970',
    name: 'FOC Motor Scheme',
  },
  {
    id: 3034,
    code: '974',
    name: 'FOC Collector',
  },
  {
    id: 3035,
    code: '295',
    name: 'FOC Private Car',
  },
  {
    id: 3036,
    code: '890',
    name: 'LCUK Motor Scheme',
  },
  {
    id: 3037,
    code: '891',
    name: 'LCUK Collector',
  },
  {
    id: 3038,
    code: '893',
    name: 'LCUK Private Car',
  },
  {
    id: 3039,
    code: '886',
    name: 'MCUK Motor Scheme',
  },
  {
    id: 3040,
    code: '887',
    name: 'MCUK Collector',
  },
  {
    id: 3041,
    code: '889',
    name: 'MCUK Private Car',
  },
  {
    id: 3042,
    code: '963',
    name: 'Collector',
  },
  {
    id: 3043,
    code: '966',
    name: 'Specialist Vehicle',
  },
  {
    id: 3044,
    code: '251',
    name: 'Motor Private Car',
  },
  {
    id: 3045,
    code: '399',
    name: 'Collections',
  },
];

export const TEMP_COB_DATA_LATAM: TempCobMeta[] = [
  { id: 2039, code: '262', name: 'Group Income Protection' },
  { id: 2040, code: '454', name: 'Personal Accident' },
  { id: 2041, code: '599', name: 'Clinical Advisory Services' },
  { id: 2042, code: '602', name: 'Dental' },
  { id: 2043, code: '625', name: 'Private Medical Insurance' },
  { id: 2044, code: '640', name: 'Group Life Assurance' },
  { id: 2045, code: '652', name: 'Key Person Insurance' },
  { id: 2046, code: '699', name: 'Group Critical Illness' },
  { id: 2047, code: '715', name: 'International Private Medical' },
  { id: 2048, code: '720', name: 'Employee Assistance Programme' },
  { id: 2049, code: '721', name: 'Cashplan' },
  { id: 2050, code: '722', name: 'Health Screen' },
  { id: 2051, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2052, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2053, code: '111', name: 'Employers Liability' },
  { id: 2054, code: '112', name: 'Public & Products Liability' },
  { id: 2055, code: '113', name: 'Public Liability' },
  { id: 2056, code: '116', name: 'Combined Liability' },
  { id: 2057, code: '117', name: 'Directors & Officers Liability' },
  { id: 2058, code: '119', name: 'Products Guarantee' },
  { id: 2059, code: '121', name: 'Products Liability' },
  { id: 2060, code: '123', name: 'Pension Fund Trustees Liability' },
  { id: 2061, code: '124', name: 'Management Liabilities Package' },
  { id: 2062, code: '127', name: 'Employment Practices Liability' },
  { id: 2063, code: '132', name: 'Products Recall' },
  { id: 2064, code: '141', name: 'Libel & Slander' },
  { id: 2065, code: '146', name: 'Non Negligence Liability' },
  { id: 2066, code: '151', name: 'Charity Trustees Liability' },
  { id: 2067, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2068, code: '155', name: 'Property Owners Liability' },
  { id: 2069, code: '169', name: 'Medical Malpractice' },
  { id: 2070, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2071, code: '183', name: 'Cyber Liability' },
  { id: 2072, code: '203', name: 'Motor Fleet' },
  { id: 2073, code: '204', name: 'Motor Traders Combined' },
  { id: 2074, code: '207', name: 'Motor Traders Road Risks' },
  { id: 2075, code: '208', name: 'Motor Traders Internal Risks' },
  { id: 2076, code: '210', name: 'Motor Special Types' },
  { id: 2077, code: '214', name: 'Motor Agricultural' },
  { id: 2078, code: '215', name: 'Motor Excess Property Damage' },
  { id: 2079, code: '251', name: 'Motor Private Car' },
  { id: 2080, code: '264', name: 'Loss Recovery' },
  { id: 2081, code: '291', name: 'Advertisers Wrap' },
  { id: 2082, code: '292', name: 'Airside Liability' },
  { id: 2083, code: '300', name: 'Self-Drive Hire' },
  { id: 2084, code: '301', name: 'Commercial Combined' },
  { id: 2085, code: '303', name: 'Computers' },
  { id: 2086, code: '305', name: 'Engineering' },
  { id: 2087, code: '306', name: 'Property Owners Combined' },
  { id: 2089, code: '308', name: 'Contingency' },
  { id: 2090, code: '310', name: 'Goods in Transit' },
  { id: 2091, code: '311', name: 'Engineering Inspection' },
  { id: 2092, code: '314', name: 'Package Policy Hoteliers' },
  { id: 2093, code: '316', name: 'Contractors All Risks' },
  { id: 2095, code: '321', name: 'Deterioration of Stock' },
  { id: 2096, code: '322', name: 'Engineering Hired in Plant' },
  { id: 2097, code: '324', name: 'Jewellers Block Insurance' },
  { id: 2098, code: '326', name: 'Material Damage' },
  { id: 2099, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2100, code: '331', name: 'Engineering Consequential Loss' },
  { id: 2101, code: '333', name: 'Material Damage and Business Int' },
  { id: 2102, code: '334', name: 'Asset All Risk' },
  { id: 2103, code: '335', name: 'Engineering Combined' },
  { id: 2104, code: '336', name: 'Contractors Combined Project' },
  { id: 2105, code: '340', name: 'Engineering Plant All Risks' },
  { id: 2106, code: '344', name: 'Agricultural Property' },
  { id: 2107, code: '346', name: 'Stock Throughput' },
  { id: 2108, code: '354', name: 'Contractors Combined' },
  { id: 2109, code: '355', name: 'Product Contamination' },
  { id: 2110, code: '359', name: 'Latent Defects' },
  { id: 2111, code: '361', name: 'Engineering Machinery Movement' },
  { id: 2112, code: '364', name: 'JCT 651 or equivalent' },
  { id: 2113, code: '380', name: 'Bloodstock' },
  { id: 2114, code: '383', name: 'Contractors Liability' },
  { id: 2115, code: '385', name: 'Yacht & Small Craft' },
  { id: 2116, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2117, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2118, code: '394', name: 'Erection All Risks & TP Liability' },
  { id: 2119, code: '401', name: 'Legal Expenses' },
  { id: 2120, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2121, code: '407', name: 'Special Contingency' },
  { id: 2122, code: '408', name: 'Bond H M Customs & Excise' },
  { id: 2123, code: '410', name: 'Crime' },
  { id: 2124, code: '414', name: 'Restrictive Covenant' },
  { id: 2125, code: '415', name: 'Event Insurance' },
  { id: 2126, code: '417', name: 'Bond Performance' },
  { id: 2127, code: '426', name: 'Intellectual Property Rights' },
  { id: 2128, code: '430', name: 'Financial Lines Combined' },
  { id: 2129, code: '434', name: 'Flood Excess' },
  { id: 2130, code: '436', name: 'Package Policy Technology' },
  { id: 2131, code: '454', name: 'Personal Accident' },
  { id: 2132, code: '456', name: 'Personal Accident & Travel' },
  { id: 2133, code: '457', name: 'Personal Accident & Sickness' },
  { id: 2134, code: '461', name: 'Travel Insurance' },
  { id: 2135, code: '484', name: 'Motor Classic Car' },
  { id: 2136, code: '501', name: 'Aircraft Hull' },
  { id: 2137, code: '503', name: 'Aviation Liability' },
  { id: 2138, code: '520', name: 'Marina Operators Liability' },
  { id: 2139, code: '523', name: 'Marine Hull & Liability' },
  { id: 2140, code: '525', name: 'Marine Craft' },
  { id: 2141, code: '527', name: 'Marine Liability' },
  { id: 2142, code: '529', name: 'Cargo' },
  { id: 2143, code: '530', name: 'Marine Hull' },
  { id: 2144, code: '551', name: 'Hauliers Liability' },
  { id: 2145, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2146, code: '558', name: 'Motor Haulage' },
  { id: 2147, code: '749', name: 'Cyber Liability PI Crime Cyber' },
  { id: 2148, code: '857', name: 'Contractors Pollution Liability' },
  { id: 2149, code: '901', name: 'Package Policy Shopkeepers' },
  { id: 2150, code: '902', name: 'Package Policy Agricultural' },
  { id: 2151, code: '904', name: 'Tour Operators' },
  { id: 2152, code: '911', name: 'Fine Arts Insurance' },
  { id: 2153, code: '920', name: 'RTA Risk' },
  { id: 2154, code: '943', name: 'Motor Legal Expenses' },
  { id: 2155, code: '972', name: 'Medical Repatriation' },
  { id: 2394, code: '503', name: 'Aviation Liability' },
  { id: 2395, code: '251', name: 'Motor Private Car' },
  { id: 2396, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2397, code: '530', name: 'Marine Hull' },
  { id: 2398, code: '404', name: 'Bonds' },
  { id: 2399, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2400, code: '301', name: 'Commercial Combined' },
  { id: 2401, code: '403', name: 'Trade Credit Insurance' },
  { id: 2402, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2403, code: '344', name: 'Agricultural Property' },
  { id: 2404, code: '569', name: 'FIRE' },
  { id: 2405, code: '529', name: 'Cargo' },
  { id: 2406, code: '252', name: 'Motorcycle' },
  { id: 2407, code: '112', name: 'Public & Products Liability' },
  { id: 2408, code: '169', name: 'Medical Malpractice' },
  { id: 2409, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2410, code: '155', name: 'Property Owners Liability' },
  { id: 2411, code: '410', name: 'Crime' },
  { id: 2412, code: '303', name: 'Computers' },
  { id: 2413, code: '333', name: 'Material Damage and Business Int' },
  { id: 2414, code: '577', name: 'Construction Combined' },
  { id: 2415, code: '219', name: 'Equipment Physical Damage' },
  { id: 2416, code: '911', name: 'Fine Arts Insurance' },
  { id: 2417, code: '415', name: 'Event Insurance' },
  { id: 2418, code: '307', name: 'Terrorism' },
  { id: 2419, code: '005', name: 'Property Damage' },
  { id: 2420, code: '116', name: 'Combined Liability' },
  { id: 2421, code: '117', name: 'Directors & Officers Liability' },
  { id: 2422, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2423, code: '183', name: 'Cyber Liability' },
  { id: 2424, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2425, code: '520', name: 'Marina Operators Liability' },
  { id: 2426, code: '111', name: 'Employers Liability' },
  { id: 2427, code: '523', name: 'Marine Hull & Liability' },
  { id: 2428, code: '121', name: 'Products Liability' },
  { id: 2429, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2430, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2431, code: '139', name: 'Clinical Trials' },
  { id: 2432, code: '167', name: 'Prof Indty Engineers' },
  { id: 2433, code: '011', name: 'Motor Liability' },
  { id: 2434, code: '203', name: 'Motor Fleet' },
  { id: 2435, code: '527', name: 'Marine Liability' },
  { id: 2436, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2437, code: '432', name: 'Contractual Financial Loss' },
  { id: 2438, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2439, code: '374', name: 'Livestock' },
  { id: 2440, code: '486', name: 'Marine Port Package' },
  { id: 2441, code: '501', name: 'Aircraft Hull' },
  { id: 2442, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2443, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2444, code: 'ARE', name: 'Airport Liability' },
  { id: 2445, code: '334', name: 'Asset All Risk' },
  { id: 2446, code: 'ENPR', name: 'Energy Property' },
  { id: 2447, code: 'TPL', name: 'Energy Liability' },
  { id: 2448, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2449, code: '102', name: 'Fee' },
  { id: 2450, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2451, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2452, code: 'ELI', name: 'Excess Liability' },
  { id: 2453, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2454, code: '210', name: 'Motor Special Types' },
  { id: 2455, code: '306', name: 'Property Owners Combined' },
  { id: 2456, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2457, code: '305', name: 'Engineering' },
  { id: 2458, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2459, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2460, code: '316', name: 'Contractors All Risks' },
  { id: 2461, code: 'LOP', name: 'Loss of Profits' },
  { id: 2462, code: '012', name: 'Erection All Risks' },
  { id: 2463, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2464, code: '301', name: 'Commercial Combined' },
  { id: 2465, code: '577', name: 'Construction Combined' },
  { id: 2466, code: '303', name: 'Computers' },
  { id: 2467, code: '410', name: 'Crime' },
  { id: 2468, code: '219', name: 'Equipment Physical Damage' },
  { id: 2469, code: '911', name: 'Fine Arts Insurance' },
  { id: 2470, code: '415', name: 'Event Insurance' },
  { id: 2471, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2472, code: '251', name: 'Motor Private Car' },
  { id: 2473, code: '307', name: 'Terrorism' },
  { id: 2474, code: '005', name: 'Property Damage' },
  { id: 2475, code: '116', name: 'Combined Liability' },
  { id: 2476, code: '117', name: 'Directors & Officers Liability' },
  { id: 2477, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2478, code: '183', name: 'Cyber Liability' },
  { id: 2479, code: '155', name: 'Property Owners Liability' },
  { id: 2480, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2481, code: '520', name: 'Marina Operators Liability' },
  { id: 2482, code: '111', name: 'Employers Liability' },
  { id: 2483, code: '523', name: 'Marine Hull & Liability' },
  { id: 2484, code: '112', name: 'Public & Products Liability' },
  { id: 2485, code: '121', name: 'Products Liability' },
  { id: 2486, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2487, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2488, code: '139', name: 'Clinical Trials' },
  { id: 2489, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2490, code: '167', name: 'Prof Indty Engineers' },
  { id: 2491, code: '011', name: 'Motor Liability' },
  { id: 2492, code: '203', name: 'Motor Fleet' },
  { id: 2493, code: '529', name: 'Cargo' },
  { id: 2494, code: '527', name: 'Marine Liability' },
  { id: 2495, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2496, code: '432', name: 'Contractual Financial Loss' },
  { id: 2497, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2498, code: '403', name: 'Trade Credit Insurance' },
  { id: 2499, code: '404', name: 'Bonds' },
  { id: 2500, code: '344', name: 'Agricultural Property' },
  { id: 2501, code: '374', name: 'Livestock' },
  { id: 2502, code: '486', name: 'Marine Port Package' },
  { id: 2503, code: '530', name: 'Marine Hull' },
  { id: 2504, code: '503', name: 'Aviation Liability' },
  { id: 2505, code: '501', name: 'Aircraft Hull' },
  { id: 2506, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2507, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2508, code: 'ARE', name: 'Airport Liability' },
  { id: 2509, code: '334', name: 'Asset All Risk' },
  { id: 2510, code: 'ENPR', name: 'Energy Property' },
  { id: 2511, code: 'TPL', name: 'Energy Liability' },
  { id: 2512, code: '169', name: 'Medical Malpractice' },
  { id: 2513, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2514, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2515, code: '102', name: 'Fee' },
  { id: 2516, code: '569', name: 'FIRE' },
  { id: 2517, code: '252', name: 'Motorcycle' },
  { id: 2518, code: '333', name: 'Material Damage and Business Int' },
  { id: 2519, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2520, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2521, code: 'ELI', name: 'Excess Liability' },
  { id: 2522, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2523, code: '210', name: 'Motor Special Types' },
  { id: 2524, code: '306', name: 'Property Owners Combined' },
  { id: 2525, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2526, code: '305', name: 'Engineering' },
  { id: 2527, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2528, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2529, code: '316', name: 'Contractors All Risks' },
  { id: 2530, code: '012', name: 'Erection All Risks' },
  { id: 2531, code: 'LOP', name: 'Loss of Profits' },
  { id: 2532, code: '251', name: 'Motor Private Car' },
  { id: 2533, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2534, code: '501', name: 'Aircraft Hull' },
  { id: 2535, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2536, code: '530', name: 'Marine Hull' },
  { id: 2537, code: '486', name: 'Marine Port Package' },
  { id: 2538, code: '403', name: 'Trade Credit Insurance' },
  { id: 2539, code: '183', name: 'Cyber Liability' },
  { id: 2540, code: '117', name: 'Directors & Officers Liability' },
  { id: 2541, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2542, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2543, code: '303', name: 'Computers' },
  { id: 2544, code: '219', name: 'Equipment Physical Damage' },
  { id: 2545, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2546, code: '404', name: 'Bonds' },
  { id: 2547, code: '529', name: 'Cargo' },
  { id: 2548, code: '569', name: 'FIRE' },
  { id: 2549, code: '344', name: 'Agricultural Property' },
  { id: 2550, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2551, code: '334', name: 'Asset All Risk' },
  { id: 2552, code: '252', name: 'Motorcycle' },
  { id: 2553, code: '911', name: 'Fine Arts Insurance' },
  { id: 2554, code: '005', name: 'Property Damage' },
  { id: 2555, code: '112', name: 'Public & Products Liability' },
  { id: 2556, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2557, code: 'ELI', name: 'Excess Liability' },
  { id: 2558, code: '121', name: 'Products Liability' },
  { id: 2559, code: '527', name: 'Marine Liability' },
  { id: 2560, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2561, code: '410', name: 'Crime' },
  { id: 2562, code: '307', name: 'Terrorism' },
  { id: 2563, code: '577', name: 'Construction Combined' },
  { id: 2564, code: '333', name: 'Material Damage and Business Int' },
  { id: 2565, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2566, code: '210', name: 'Motor Special Types' },
  { id: 2567, code: '503', name: 'Aviation Liability' },
  { id: 2568, code: '301', name: 'Commercial Combined' },
  { id: 2569, code: '169', name: 'Medical Malpractice' },
  { id: 2570, code: '155', name: 'Property Owners Liability' },
  { id: 2571, code: '415', name: 'Event Insurance' },
  { id: 2572, code: '116', name: 'Combined Liability' },
  { id: 2573, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2574, code: '520', name: 'Marina Operators Liability' },
  { id: 2575, code: '111', name: 'Employers Liability' },
  { id: 2576, code: '523', name: 'Marine Hull & Liability' },
  { id: 2577, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2578, code: '139', name: 'Clinical Trials' },
  { id: 2579, code: '167', name: 'Prof Indty Engineers' },
  { id: 2580, code: '011', name: 'Motor Liability' },
  { id: 2581, code: '203', name: 'Motor Fleet' },
  { id: 2582, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2583, code: '432', name: 'Contractual Financial Loss' },
  { id: 2584, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2585, code: '374', name: 'Livestock' },
  { id: 2586, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2587, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2588, code: 'ARE', name: 'Airport Liability' },
  { id: 2589, code: 'ENPR', name: 'Energy Property' },
  { id: 2590, code: 'TPL', name: 'Energy Liability' },
  { id: 2591, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2592, code: '102', name: 'Fee' },
  { id: 2593, code: '306', name: 'Property Owners Combined' },
  { id: 2594, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2595, code: '305', name: 'Engineering' },
  { id: 2596, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2597, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2598, code: '316', name: 'Contractors All Risks' },
  { id: 2599, code: '012', name: 'Erection All Risks' },
  { id: 2600, code: '344', name: 'Agricultural Property' },
  { id: 2601, code: '432', name: 'Contractual Financial Loss' },
  { id: 2602, code: '251', name: 'Motor Private Car' },
  { id: 2603, code: '203', name: 'Motor Fleet' },
  { id: 2604, code: '252', name: 'Motorcycle' },
  { id: 2605, code: '210', name: 'Motor Special Types' },
  { id: 2606, code: '501', name: 'Aircraft Hull' },
  { id: 2607, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2608, code: '334', name: 'Asset All Risk' },
  { id: 2609, code: '530', name: 'Marine Hull' },
  { id: 2610, code: '306', name: 'Property Owners Combined' },
  { id: 2611, code: '404', name: 'Bonds' },
  { id: 2612, code: '183', name: 'Cyber Liability' },
  { id: 2613, code: '117', name: 'Directors & Officers Liability' },
  { id: 2614, code: '303', name: 'Computers' },
  { id: 2615, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2616, code: '569', name: 'FIRE' },
  { id: 2617, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2618, code: 'LOP', name: 'Loss of Profits' },
  { id: 2619, code: '374', name: 'Livestock' },
  { id: 2620, code: '301', name: 'Commercial Combined' },
  { id: 2621, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2622, code: '112', name: 'Public & Products Liability' },
  { id: 2623, code: '169', name: 'Medical Malpractice' },
  { id: 2624, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2625, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2626, code: '403', name: 'Trade Credit Insurance' },
  { id: 2627, code: '011', name: 'Motor Liability' },
  { id: 2628, code: '410', name: 'Crime' },
  { id: 2629, code: '577', name: 'Construction Combined' },
  { id: 2630, code: '005', name: 'Property Damage' },
  { id: 2631, code: '305', name: 'Engineering' },
  { id: 2632, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2633, code: '529', name: 'Cargo' },
  { id: 2634, code: '503', name: 'Aviation Liability' },
  { id: 2635, code: '155', name: 'Property Owners Liability' },
  { id: 2636, code: '333', name: 'Material Damage and Business Int' },
  { id: 2637, code: '219', name: 'Equipment Physical Damage' },
  { id: 2638, code: '911', name: 'Fine Arts Insurance' },
  { id: 2639, code: '415', name: 'Event Insurance' },
  { id: 2640, code: '307', name: 'Terrorism' },
  { id: 2641, code: '116', name: 'Combined Liability' },
  { id: 2642, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2643, code: '520', name: 'Marina Operators Liability' },
  { id: 2644, code: '111', name: 'Employers Liability' },
  { id: 2645, code: '523', name: 'Marine Hull & Liability' },
  { id: 2646, code: '121', name: 'Products Liability' },
  { id: 2647, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2648, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2649, code: '139', name: 'Clinical Trials' },
  { id: 2650, code: '167', name: 'Prof Indty Engineers' },
  { id: 2651, code: '527', name: 'Marine Liability' },
  { id: 2652, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2653, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2654, code: '486', name: 'Marine Port Package' },
  { id: 2655, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2656, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2657, code: 'ARE', name: 'Airport Liability' },
  { id: 2658, code: 'ENPR', name: 'Energy Property' },
  { id: 2659, code: 'TPL', name: 'Energy Liability' },
  { id: 2660, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2661, code: '102', name: 'Fee' },
  { id: 2662, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2663, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2664, code: 'ELI', name: 'Excess Liability' },
  { id: 2665, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2666, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2667, code: '316', name: 'Contractors All Risks' },
  { id: 2668, code: '012', name: 'Erection All Risks' },
  { id: 2669, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2670, code: '203', name: 'Motor Fleet' },
  { id: 2671, code: '210', name: 'Motor Special Types' },
  { id: 2672, code: '252', name: 'Motorcycle' },
  { id: 2673, code: '301', name: 'Commercial Combined' },
  { id: 2674, code: '334', name: 'Asset All Risk' },
  { id: 2675, code: '529', name: 'Cargo' },
  { id: 2676, code: '569', name: 'FIRE' },
  { id: 2677, code: '530', name: 'Marine Hull' },
  { id: 2678, code: '112', name: 'Public & Products Liability' },
  { id: 2679, code: '102', name: 'Fee' },
  { id: 2680, code: '307', name: 'Terrorism' },
  { id: 2681, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2682, code: '403', name: 'Trade Credit Insurance' },
  { id: 2683, code: '404', name: 'Bonds' },
  { id: 2684, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2685, code: '183', name: 'Cyber Liability' },
  { id: 2686, code: '117', name: 'Directors & Officers Liability' },
  { id: 2687, code: '155', name: 'Property Owners Liability' },
  { id: 2688, code: '503', name: 'Aviation Liability' },
  { id: 2689, code: '251', name: 'Motor Private Car' },
  { id: 2690, code: '344', name: 'Agricultural Property' },
  { id: 2691, code: '169', name: 'Medical Malpractice' },
  { id: 2692, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2693, code: '410', name: 'Crime' },
  { id: 2694, code: '303', name: 'Computers' },
  { id: 2695, code: '333', name: 'Material Damage and Business Int' },
  { id: 2696, code: '577', name: 'Construction Combined' },
  { id: 2697, code: '219', name: 'Equipment Physical Damage' },
  { id: 2698, code: '911', name: 'Fine Arts Insurance' },
  { id: 2699, code: '415', name: 'Event Insurance' },
  { id: 2700, code: '005', name: 'Property Damage' },
  { id: 2701, code: '116', name: 'Combined Liability' },
  { id: 2702, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2703, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2704, code: '520', name: 'Marina Operators Liability' },
  { id: 2705, code: '111', name: 'Employers Liability' },
  { id: 2706, code: '523', name: 'Marine Hull & Liability' },
  { id: 2707, code: '121', name: 'Products Liability' },
  { id: 2708, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2709, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2710, code: '139', name: 'Clinical Trials' },
  { id: 2711, code: '167', name: 'Prof Indty Engineers' },
  { id: 2712, code: '011', name: 'Motor Liability' },
  { id: 2713, code: '527', name: 'Marine Liability' },
  { id: 2714, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2715, code: '432', name: 'Contractual Financial Loss' },
  { id: 2716, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2717, code: '374', name: 'Livestock' },
  { id: 2718, code: '486', name: 'Marine Port Package' },
  { id: 2719, code: '501', name: 'Aircraft Hull' },
  { id: 2720, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2721, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2722, code: 'ARE', name: 'Airport Liability' },
  { id: 2723, code: 'ENPR', name: 'Energy Property' },
  { id: 2724, code: 'TPL', name: 'Energy Liability' },
  { id: 2725, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2726, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2727, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2728, code: 'ELI', name: 'Excess Liability' },
  { id: 2729, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2730, code: '306', name: 'Property Owners Combined' },
  { id: 2731, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2732, code: '305', name: 'Engineering' },
  { id: 2733, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2734, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2735, code: '316', name: 'Contractors All Risks' },
  { id: 2736, code: '012', name: 'Erection All Risks' },
  { id: 2737, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2738, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2739, code: '501', name: 'Aircraft Hull' },
  { id: 2740, code: '011', name: 'Motor Liability' },
  { id: 2741, code: '530', name: 'Marine Hull' },
  { id: 2742, code: '404', name: 'Bonds' },
  { id: 2743, code: '183', name: 'Cyber Liability' },
  { id: 2744, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2745, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2746, code: '102', name: 'Fee' },
  { id: 2747, code: '569', name: 'FIRE' },
  { id: 2748, code: '301', name: 'Commercial Combined' },
  { id: 2749, code: '112', name: 'Public & Products Liability' },
  { id: 2750, code: '410', name: 'Crime' },
  { id: 2751, code: '316', name: 'Contractors All Risks' },
  { id: 2752, code: '303', name: 'Computers' },
  { id: 2753, code: '012', name: 'Erection All Risks' },
  { id: 2754, code: '529', name: 'Cargo' },
  { id: 2755, code: '251', name: 'Motor Private Car' },
  { id: 2756, code: '503', name: 'Aviation Liability' },
  { id: 2757, code: '403', name: 'Trade Credit Insurance' },
  { id: 2758, code: '344', name: 'Agricultural Property' },
  { id: 2759, code: '252', name: 'Motorcycle' },
  { id: 2760, code: '169', name: 'Medical Malpractice' },
  { id: 2761, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2762, code: '155', name: 'Property Owners Liability' },
  { id: 2763, code: '333', name: 'Material Damage and Business Int' },
  { id: 2764, code: '577', name: 'Construction Combined' },
  { id: 2765, code: '219', name: 'Equipment Physical Damage' },
  { id: 2766, code: '911', name: 'Fine Arts Insurance' },
  { id: 2767, code: '415', name: 'Event Insurance' },
  { id: 2768, code: '307', name: 'Terrorism' },
  { id: 2769, code: '005', name: 'Property Damage' },
  { id: 2770, code: '116', name: 'Combined Liability' },
  { id: 2771, code: '117', name: 'Directors & Officers Liability' },
  { id: 2772, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2773, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2774, code: '520', name: 'Marina Operators Liability' },
  { id: 2775, code: '111', name: 'Employers Liability' },
  { id: 2776, code: '523', name: 'Marine Hull & Liability' },
  { id: 2777, code: '121', name: 'Products Liability' },
  { id: 2778, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2779, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2780, code: '139', name: 'Clinical Trials' },
  { id: 2781, code: '167', name: 'Prof Indty Engineers' },
  { id: 2782, code: '203', name: 'Motor Fleet' },
  { id: 2783, code: '527', name: 'Marine Liability' },
  { id: 2784, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2785, code: '432', name: 'Contractual Financial Loss' },
  { id: 2786, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2787, code: '374', name: 'Livestock' },
  { id: 2788, code: '486', name: 'Marine Port Package' },
  { id: 2789, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2790, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2791, code: 'ARE', name: 'Airport Liability' },
  { id: 2792, code: '334', name: 'Asset All Risk' },
  { id: 2793, code: 'ENPR', name: 'Energy Property' },
  { id: 2794, code: 'TPL', name: 'Energy Liability' },
  { id: 2795, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2796, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2797, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2798, code: 'ELI', name: 'Excess Liability' },
  { id: 2799, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2800, code: '210', name: 'Motor Special Types' },
  { id: 2801, code: '306', name: 'Property Owners Combined' },
  { id: 2802, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2803, code: '305', name: 'Engineering' },
  { id: 2804, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2805, code: '344', name: 'Agricultural Property' },
  { id: 2806, code: '530', name: 'Marine Hull' },
  { id: 2807, code: '301', name: 'Commercial Combined' },
  { id: 2808, code: '403', name: 'Trade Credit Insurance' },
  { id: 2809, code: '404', name: 'Bonds' },
  { id: 2810, code: '569', name: 'FIRE' },
  { id: 2811, code: '112', name: 'Public & Products Liability' },
  { id: 2812, code: '011', name: 'Motor Liability' },
  { id: 2813, code: '529', name: 'Cargo' },
  { id: 2814, code: '251', name: 'Motor Private Car' },
  { id: 2815, code: '289', name: 'Home and Motor Portfolio' },
  { id: 2816, code: '503', name: 'Aviation Liability' },
  { id: 2817, code: '402', name: 'Fidelity Guarantee Employee' },
  { id: 2818, code: '252', name: 'Motorcycle' },
  { id: 2819, code: '169', name: 'Medical Malpractice' },
  { id: 2820, code: '175', name: 'Professional Indemnity E&O' },
  { id: 2821, code: '155', name: 'Property Owners Liability' },
  { id: 2822, code: '410', name: 'Crime' },
  { id: 2823, code: '303', name: 'Computers' },
  { id: 2824, code: '333', name: 'Material Damage and Business Int' },
  { id: 2825, code: 'BBB', name: 'Bankers Blanket Bond' },
  { id: 2826, code: '577', name: 'Construction Combined' },
  { id: 2827, code: '219', name: 'Equipment Physical Damage' },
  { id: 2828, code: '911', name: 'Fine Arts Insurance' },
  { id: 2829, code: '415', name: 'Event Insurance' },
  { id: 2830, code: '307', name: 'Terrorism' },
  { id: 2831, code: '005', name: 'Property Damage' },
  { id: 2832, code: '116', name: 'Combined Liability' },
  { id: 2833, code: '117', name: 'Directors & Officers Liability' },
  { id: 2834, code: '152', name: 'Environmental Impairment Liab' },
  { id: 2835, code: '183', name: 'Cyber Liability' },
  { id: 2836, code: '389', name: 'Warehouse Keepers Liability' },
  { id: 2837, code: '520', name: 'Marina Operators Liability' },
  { id: 2838, code: '111', name: 'Employers Liability' },
  { id: 2839, code: '523', name: 'Marine Hull & Liability' },
  { id: 2840, code: '121', name: 'Products Liability' },
  { id: 2841, code: '164', name: 'Prof Indty Insurance Brokers' },
  { id: 2842, code: '184', name: 'Prof Indty Financial Services' },
  { id: 2843, code: '139', name: 'Clinical Trials' },
  { id: 2844, code: '167', name: 'Prof Indty Engineers' },
  { id: 2845, code: '203', name: 'Motor Fleet' },
  { id: 2846, code: '527', name: 'Marine Liability' },
  { id: 2847, code: '552', name: 'Freight Forwarders Liability' },
  { id: 2848, code: '432', name: 'Contractual Financial Loss' },
  { id: 2849, code: '360', name: 'Loss of Anticipated Rental Income' },
  { id: 2850, code: '374', name: 'Livestock' },
  { id: 2851, code: '486', name: 'Marine Port Package' },
  { id: 2852, code: '501', name: 'Aircraft Hull' },
  { id: 2853, code: 'HUW', name: 'Aircraft Hull War' },
  { id: 2854, code: 'APH', name: 'Aviation Hangar keepers Liability' },
  { id: 2855, code: 'ARE', name: 'Airport Liability' },
  { id: 2856, code: '334', name: 'Asset All Risk' },
  { id: 2857, code: 'ENPR', name: 'Energy Property' },
  { id: 2858, code: 'TPL', name: 'Energy Liability' },
  { id: 2859, code: '125', name: 'Prof Indty Solicitors' },
  { id: 2860, code: '102', name: 'Fee' },
  { id: 2861, code: 'AHL', name: 'Aircraft Hull & Liability' },
  { id: 2862, code: '393', name: 'Contractors Plant and Equipment' },
  { id: 2863, code: 'ELI', name: 'Excess Liability' },
  { id: 2864, code: '202', name: 'Motor Commercial Vehicle' },
  { id: 2865, code: '210', name: 'Motor Special Types' },
  { id: 2866, code: '306', name: 'Property Owners Combined' },
  { id: 2867, code: '328', name: 'Engineering Machinery Breakdown' },
  { id: 2868, code: '305', name: 'Engineering' },
  { id: 2869, code: 'ACR', name: 'Armored Car Transit Risks' },
  { id: 2870, code: 'CFP', name: 'Contract Frustration Non Payment' },
  { id: 2871, code: '316', name: 'Contractors All Risks' },
  { id: 2872, code: '012', name: 'Erection All Risks' },
  { id: 2873, code: '102', name: 'Fee' },
  { id: 2874, code: '454', name: 'Personal Accident' },
  { id: 2875, code: '452', name: 'Group Personal Accident' },
  { id: 2876, code: 'WCA', name: 'Workers Compensation' },
  { id: 2877, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2878, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2879, code: '625', name: 'Private Medical Insurance' },
  { id: 2880, code: '595', name: 'Funeral' },
  { id: 2881, code: '640', name: 'Group Life Assurance' },
  { id: 2882, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2883, code: '262', name: 'Group Income Protection' },
  { id: 2884, code: '602', name: 'Dental' },
  { id: 2885, code: '441', name: 'Pharmacists' },
  { id: 2886, code: '699', name: 'Group Critical Illness' },
  { id: 2887, code: '446', name: 'Communications (Benefits)' },
  { id: 2888, code: '456', name: 'Personal Accident & Travel' },
  { id: 2889, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2890, code: '262', name: 'Group Income Protection' },
  { id: 2891, code: '452', name: 'Group Personal Accident' },
  { id: 2892, code: '640', name: 'Group Life Assurance' },
  { id: 2893, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2894, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2895, code: '454', name: 'Personal Accident' },
  { id: 2896, code: '625', name: 'Private Medical Insurance' },
  { id: 2897, code: '602', name: 'Dental' },
  { id: 2898, code: '441', name: 'Pharmacists' },
  { id: 2899, code: '699', name: 'Group Critical Illness' },
  { id: 2900, code: '446', name: 'Communications (Benefits)' },
  { id: 2901, code: '102', name: 'Fee' },
  { id: 2902, code: '456', name: 'Personal Accident & Travel' },
  { id: 2903, code: '454', name: 'Personal Accident' },
  { id: 2904, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2905, code: '625', name: 'Private Medical Insurance' },
  { id: 2906, code: '102', name: 'Fee' },
  { id: 2907, code: '640', name: 'Group Life Assurance' },
  { id: 2908, code: '452', name: 'Group Personal Accident' },
  { id: 2909, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2910, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2911, code: '262', name: 'Group Income Protection' },
  { id: 2912, code: '602', name: 'Dental' },
  { id: 2913, code: '441', name: 'Pharmacists' },
  { id: 2914, code: '699', name: 'Group Critical Illness' },
  { id: 2915, code: '446', name: 'Communications (Benefits)' },
  { id: 2916, code: '456', name: 'Personal Accident & Travel' },
  { id: 2917, code: '454', name: 'Personal Accident' },
  { id: 2918, code: '456', name: 'Personal Accident & Travel' },
  { id: 2919, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2920, code: '625', name: 'Private Medical Insurance' },
  { id: 2921, code: '699', name: 'Group Critical Illness' },
  { id: 2922, code: '640', name: 'Group Life Assurance' },
  { id: 2923, code: '102', name: 'Fee' },
  { id: 2924, code: '602', name: 'Dental' },
  { id: 2925, code: '595', name: 'Funeral' },
  { id: 2926, code: '595', name: 'Funeral' },
  { id: 2927, code: '262', name: 'Group Income Protection' },
  { id: 2928, code: '452', name: 'Group Personal Accident' },
  { id: 2929, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2930, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2931, code: '441', name: 'Pharmacists' },
  { id: 2932, code: '446', name: 'Communications (Benefits)' },
  { id: 2933, code: 'WCA', name: 'Workers Compensation' },
  { id: 2934, code: '625', name: 'Private Medical Insurance' },
  { id: 2935, code: '640', name: 'Group Life Assurance' },
  { id: 2936, code: '452', name: 'Group Personal Accident' },
  { id: 2937, code: '102', name: 'Fee' },
  { id: 2938, code: '699', name: 'Group Critical Illness' },
  { id: 2939, code: '454', name: 'Personal Accident' },
  { id: 2940, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2941, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2942, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2943, code: '262', name: 'Group Income Protection' },
  { id: 2944, code: '602', name: 'Dental' },
  { id: 2945, code: '441', name: 'Pharmacists' },
  { id: 2946, code: '446', name: 'Communications (Benefits)' },
  { id: 2947, code: '456', name: 'Personal Accident & Travel' },
  { id: 2948, code: '454', name: 'Personal Accident' },
  { id: 2949, code: '625', name: 'Private Medical Insurance' },
  { id: 2950, code: '699', name: 'Group Critical Illness' },
  { id: 2951, code: 'WCA', name: 'Workers Compensation' },
  { id: 2952, code: '640', name: 'Group Life Assurance' },
  { id: 2953, code: '452', name: 'Group Personal Accident' },
  { id: 2954, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2955, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2956, code: '102', name: 'Fee' },
  { id: 2957, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2958, code: '262', name: 'Group Income Protection' },
  { id: 2959, code: '602', name: 'Dental' },
  { id: 2960, code: '441', name: 'Pharmacists' },
  { id: 2961, code: '446', name: 'Communications (Benefits)' },
  { id: 2962, code: '456', name: 'Personal Accident & Travel' },
  { id: 2963, code: 'WCA', name: 'Workers Compensation' },
  { id: 2964, code: '454', name: 'Personal Accident' },
  { id: 2965, code: '102', name: 'Fee' },
  { id: 2966, code: '625', name: 'Private Medical Insurance' },
  { id: 2967, code: '640', name: 'Group Life Assurance' },
  { id: 2968, code: '452', name: 'Group Personal Accident' },
  { id: 2969, code: '727', name: 'Travel Leisure (Benefits)' },
  { id: 2970, code: '598', name: 'Non-Advice Pensions Consultancy' },
  { id: 2971, code: '728', name: 'Travel Business (Benefits)' },
  { id: 2972, code: '262', name: 'Group Income Protection' },
  { id: 2973, code: '602', name: 'Dental' },
  { id: 2974, code: '441', name: 'Pharmacists' },
  { id: 2975, code: '699', name: 'Group Critical Illness' },
  { id: 2976, code: '446', name: 'Communications (Benefits)' },
  { id: 2977, code: '456', name: 'Personal Accident & Travel' },
  { id: 2978, code: 'MX133', name: 'Fidelidad' },
  {
    id: 2979,
    code: 'CL454',
    name: 'Huelga Disturbios Y Comisión Civil (SRCC)',
  },
  { id: 2980, code: 'MX134', name: 'Vida Grupo' },
  { id: 2981, code: 'PE135', name: '3B-Seguro De Bancos (B.B.B.)' },
  {
    id: 2982,
    code: 'PE136',
    name: '3D-Deshonestidad, Desaparición Y Destrucción',
  },
  { id: 2983, code: 'BR252', name: '75 - G.Financeira' },
  {
    id: 2984,
    code: 'BR167',
    name: 'A.P Pass. Onibus, Micro-Onibus Auto Em Geral',
  },
  { id: 2985, code: 'AR138', name: 'Accidentes A Pasajeros' },
  { id: 2986, code: 'MX369', name: 'Accidentes Colectivo' },
  { id: 2987, code: 'MX441', name: 'Accidentes Grupo' },
  { id: 2988, code: 'MX356', name: 'Accidentes Individual' },
  { id: 2989, code: 'AR125', name: 'Accidentes Personales' },
  { id: 2990, code: 'CL125', name: 'Accidentes Personales' },
  { id: 2991, code: 'CO125', name: 'Accidentes Personales' },
  { id: 2992, code: 'PE125', name: 'Accidentes Personales' },
  { id: 2993, code: 'UY125', name: 'Accidentes Personales' },
  { id: 2994, code: 'BR369', name: 'Acidentes Pessoais - P. Coletivos' },
  { id: 2995, code: 'BR385', name: 'Acidentes Pessoais - Pessoas Individual' },
  { id: 2996, code: 'MX232', name: 'Administrativa' },
  { id: 2997, code: 'UY490', name: 'Adt' },
  { id: 2998, code: 'BR310', name: 'Advogados E/Ou Escritorios De Advocacia' },
  { id: 2999, code: 'BR139', name: 'Aeronauticos (Casco)' },
  { id: 3000, code: 'BR140', name: 'Aeronauticos Guerra' },
  { id: 3001, code: 'AR150', name: 'Aeronavegación' },
  { id: 3002, code: 'BR141', name: 'Agenciamento' },
  { id: 3003, code: 'CO142', name: 'Agricola' },
  { id: 3004, code: 'UY145', name: 'Agro' },
  { id: 3005, code: 'AR100', name: 'Agro Cultivo' },
  { id: 3006, code: 'UY100', name: 'Agro Cultivo' },
  { id: 3007, code: 'CO311', name: 'Arrendamiento' },
  { id: 3008, code: 'AR490', name: 'Art' },
  { id: 3009, code: 'UY477', name: 'Asistencia Al Viajero' },
  { id: 3010, code: 'CL477', name: 'Asistencia En Viajes' },
  { id: 3011, code: 'CO477', name: 'Asistencia Internacional' },
  { id: 3012, code: 'CO269', name: 'Asistencia Medica' },
  { id: 3013, code: 'PE269', name: 'Asistencia Médica' },
  { id: 3014, code: 'BR173', name: 'Assistência Bens Em Geral' },
  { id: 3015, code: 'MX370', name: 'Auto Colectivo' },
  { id: 3016, code: 'MX491', name: 'Auto Flotilla' },
  { id: 3017, code: 'MX358', name: 'Auto Individual' },
  { id: 3018, code: 'CL325', name: 'Auto Individual Liviano' },
  { id: 3019, code: 'MX483', name: 'Autobus Flotilla' },
  { id: 3020, code: 'MX357', name: 'Autobus Individual' },
  { id: 3021, code: 'AR104', name: 'Automotores' },
  { id: 3022, code: 'UY104', name: 'Automotores' },
  { id: 3023, code: 'BR205', name: 'Automovel Compreensiva A' },
  { id: 3024, code: 'BR206', name: 'Automovel Compreensiva B' },
  { id: 3025, code: 'CO182', name: 'Automoviles' },
  { id: 3026, code: 'CO197', name: 'Automoviles Colectivo' },
  { id: 3027, code: 'CO291', name: 'Automoviles Individual' },
  { id: 3028, code: 'CO183', name: 'Automoviles Motocicletas' },
  { id: 3029, code: 'CO276', name: 'Automoviles Pesados' },
  { id: 3030, code: 'CO104', name: 'Aviacion' },
  { id: 3031, code: 'MX104', name: 'Aviacion' },
  { id: 3032, code: 'PE104', name: 'Aviacion' },
  { id: 3033, code: 'MX489', name: 'Bicicletas' },
  { id: 3034, code: 'BR175', name: 'Bike' },
  { id: 3035, code: 'PE177', name: 'Brevetes' },
  { id: 3036, code: 'MX312', name: 'Camión Flotilla' },
  { id: 3037, code: 'MX362', name: 'Camión Individual' },
  { id: 3038, code: 'CO180', name: 'Cancer' },
  { id: 3039, code: 'BR266', name: 'Carta Verde' },
  {
    id: 3040,
    code: 'CL148',
    name: 'Casco Aereo, Responsabilidad Civil Y Accidentes Personales',
  },
  {
    id: 3041,
    code: 'CL147',
    name: 'Casco Aereo, Responsabilidad Civil Y Guerra',
  },
  {
    id: 3042,
    code: 'CL149',
    name: 'Casco Aereo, Responsabilidad Civil, Accidentes Personales Y Guerra',
  },
  { id: 3043, code: 'CO170', name: 'Casco Barco' },
  { id: 3044, code: 'CL170', name: 'Casco Nave' },
  { id: 3045, code: 'CL211', name: 'Casco Puertos Y Terminales' },
  { id: 3046, code: 'UY170', name: 'Cascos' },
  { id: 3047, code: 'PE121', name: 'Cascos Marítimos' },
  { id: 3048, code: 'AR117', name: 'Cascos Y Maquinarias Del Buque' },
  { id: 3049, code: 'UR117', name: 'Cascos Y Maquinarias Del Buque' },
  { id: 3050, code: 'AR127', name: 'Caución' },
  { id: 3051, code: 'PE127', name: 'Cauciones' },
  { id: 3052, code: 'PE352', name: 'Clavo A Clavo - Obras De Arte' },
  {
    id: 3053,
    code: 'BR196',
    name: 'Clinical Trials - R.C Experimentos Clinicos',
  },
  { id: 3054, code: 'CO371', name: 'Colectivo Vida' },
  { id: 3055, code: 'CL317', name: 'Colectivo Vida Y Salud' },
  { id: 3056, code: 'UY201', name: 'Combinado' },
  { id: 3057, code: 'AR114', name: 'Combinado Familiar' },
  { id: 3058, code: 'UY114', name: 'Combinado Familiar' },
  { id: 3059, code: 'AR201', name: 'Combinados E Integrales' },
  { id: 3060, code: 'MX373', name: 'Compensaciones' },
  { id: 3061, code: 'BR208', name: 'Compreensivo Condominio' },
  { id: 3062, code: 'BR212', name: 'Compreensivo De Veiculos' },
  { id: 3063, code: 'BR178', name: 'Compreensivo Empresarial' },
  {
    id: 3064,
    code: 'BR210',
    name: 'Compreensivo Exposicoes, Congressos, Eventos',
  },
  { id: 3065, code: 'BR481', name: 'Compreensivo Operadores Aeroportuarios' },
  { id: 3066, code: 'BR211', name: 'Compreensivo Para Operadores Portuarios' },
  { id: 3067, code: 'BR438', name: 'Compreensivo Residencial' },
  { id: 3068, code: 'AR191', name: 'Construccion Y Montaje' },
  { id: 3069, code: 'MX215', name: 'Consultas' },
  { id: 3070, code: 'MX376', name: 'Consultoria' },
  { id: 3071, code: 'MX169', name: 'Consultoría Autos' },
  { id: 3072, code: 'MX377', name: 'Consultoría Beneficios' },
  { id: 3073, code: 'MX165', name: 'Consultoría Daños' },
  { id: 3074, code: 'CO217', name: 'Copropiedades' },
  { id: 3075, code: 'UY108', name: 'Creddom' },
  { id: 3076, code: 'PE108', name: 'Crédito' },
  { id: 3077, code: 'BR112', name: 'Credito A Exportacao' },
  { id: 3078, code: 'AR112', name: 'Crédito De Exportación' },
  { id: 3079, code: 'CL108', name: 'Crédito Doméstico' },
  { id: 3080, code: 'CL112', name: 'Crédito Exportación' },
  { id: 3081, code: 'BR108', name: 'Credito Interno' },
  { id: 3082, code: 'CO127', name: 'Cumplimiento' },
  { id: 3083, code: 'CO464', name: 'Cumplimiento Disposiciones Legales' },
  {
    id: 3084,
    code: 'CO465',
    name: 'Cumplimiento Disposiciones Legales Renovar',
  },
  { id: 3085, code: 'CO463', name: 'Cumplimiento Renovar' },
  { id: 3086, code: 'CL109', name: 'Cyber' },
  { id: 3087, code: 'CO109', name: 'Cyber' },
  { id: 3088, code: 'BR224', name: 'Danos / Bilhete' },
  { id: 3089, code: 'BR226', name: 'Dental Pos Pagamento' },
  { id: 3090, code: 'BR227', name: 'Dental Pre Pagamento' },
  { id: 3091, code: 'PE467', name: 'Desgravamen' },
  { id: 3092, code: 'PE231', name: 'Deshonestidad Frente A La Empresa' },
  { id: 3093, code: 'CO110', name: 'Directores & Administradores' },
  { id: 3094, code: 'PE234', name: 'Domiciliario' },
  { id: 3095, code: 'PE448', name: 'Enfermedades Graves' },
  { id: 3096, code: 'PE275', name: 'Entidad Prestadoras De Salud' },
  {
    id: 3097,
    code: 'BR240',
    name: 'Epl - R.C. Praticas Trabalhistas Indevidas',
  },
  { id: 3098, code: 'BR242', name: 'Equip. Arrendados Ou Cedidos A Terceiros' },
  {
    id: 3099,
    code: 'BR184',
    name: 'Equip. Cinem/Fotog/Telev (Local Determinado)',
  },
  { id: 3100, code: 'BR111', name: 'Equipamentos Eletronicos' },
  { id: 3101, code: 'BR241', name: 'Equipamentos Em Operacoes Sobre Agua' },
  { id: 3102, code: 'BR453', name: 'Equipamentos Estacionarios' },
  { id: 3103, code: 'BR123', name: 'Equipamentos Moveis' },
  { id: 3104, code: 'BR344', name: 'Equipamentos Moveis (Viagens De Entrega)' },
  { id: 3105, code: 'BR389', name: 'Equipamentos Portateis' },
  { id: 3106, code: 'BR293', name: 'Equipamentos Portateis Individuais' },
  { id: 3107, code: 'CL209', name: 'Equipo Contratista' },
  { id: 3108, code: 'CO111', name: 'Equipo Electronico' },
  { id: 3109, code: 'CL111', name: 'Equipo Electrónico' },
  { id: 3110, code: 'CL123', name: 'Equipo Movil' },
  { id: 3111, code: 'CL343', name: 'Equipo Movil Contratista' },
  { id: 3112, code: 'CO221', name: 'Eventos Criticos' },
  { id: 3113, code: 'CO495', name: 'Exequias' },
  { id: 3114, code: 'CO260', name: 'Exequias Iva' },
  { id: 3115, code: 'BR367', name: 'Extracao De Petroleo' },
  { id: 3116, code: 'BR387', name: 'Farmacia' },
  { id: 3117, code: 'PE248', name: 'Fee' },
  { id: 3118, code: 'BR303', name: 'Fee Internacional' },
  { id: 3119, code: 'BR437', name: 'Fianca Locaticia' },
  { id: 3120, code: 'MX482', name: 'Fianza-proveedores' },
  { id: 3121, code: 'PE128', name: 'Fianzas' },
  { id: 3122, code: 'UY128', name: 'Fianzas' },
  { id: 3123, code: 'CL133', name: 'Fidelidad – Crime' },
  { id: 3124, code: 'CL366', name: 'Fidelidad Funcionaria (Crime)' },
  { id: 3125, code: 'BR133', name: 'Fidelidade/Crime' },
  { id: 3126, code: 'AR133', name: 'Fidelity' },
  {
    id: 3127,
    code: 'BR253',
    name: 'Fipi - Resp. Prof. Instituicoes Financeiras',
  },
  { id: 3128, code: 'BR258', name: 'Framework Policy' },
  { id: 3129, code: 'CL259', name: 'Fraude' },
  { id: 3130, code: 'CL462', name: 'Garantía Para Corredores' },
  { id: 3131, code: 'BR460', name: 'Garantia Segurado - Setor Privado' },
  { id: 3132, code: 'BR461', name: 'Garantia Segurado - Setor Publico' },
  { id: 3133, code: 'MX372', name: 'Gastos Médicos Colectivo' },
  { id: 3134, code: 'MX443', name: 'Gastos Médicos Grupo' },
  { id: 3135, code: 'MX360', name: 'Gastos Médicos Individual' },
  { id: 3136, code: 'CO264', name: 'Global Comercial De Manejo' },
  { id: 3137, code: 'AR116', name: 'Granizo' },
  { id: 3138, code: 'UY116', name: 'Granizo' },
  {
    id: 3139,
    code: 'BR337',
    name: 'Habitacional De Mercado - Demais Coberturas',
  },
  { id: 3140, code: 'BR336', name: 'Habitacional De Mercado - Prestamista' },
  { id: 3141, code: 'CO466', name: 'Hospitalizacion Cirugia 1' },
  { id: 3142, code: 'CO280', name: 'Hospitalizacion Y Cirugia' },
  { id: 3143, code: 'CL246', name: 'Importación Y Exportación' },
  {
    id: 3144,
    code: 'CL287',
    name: 'Importación Y Exportación Aérea, Marítima Y Terrestre',
  },
  { id: 3145, code: 'CL334', name: 'Importación Y Exportación Marítima' },
  { id: 3146, code: 'AR115', name: 'Incendio' },
  { id: 3147, code: 'CL115', name: 'Incendio' },
  { id: 3148, code: 'CO115', name: 'Incendio' },
  { id: 3149, code: 'PE115', name: 'Incendio' },
  { id: 3150, code: 'UY115', name: 'Incendio' },
  { id: 3151, code: 'MX115', name: 'Incendio' },
  { id: 3152, code: 'CL256', name: 'Incendio Forestal' },
  { id: 3153, code: 'CL279', name: 'Incendio Hogar' },
  { id: 3154, code: 'CO295', name: 'Infidelidad Y Riesgos Financieros' },
  { id: 3155, code: 'AR119', name: 'Integral De Comercio' },
  { id: 3156, code: 'UY119', name: 'Integral De Comercio' },
  { id: 3157, code: 'AR213', name: 'Integral De Consorcio' },
  { id: 3158, code: 'AR294', name: 'Integral De Industria' },
  { id: 3159, code: 'AR299', name: 'Integral De Transporte' },
  { id: 3160, code: 'AR477', name: 'Integral De Viajero' },
  { id: 3161, code: 'CO298', name: 'Integral Hogar' },
  { id: 3162, code: 'UY297', name: 'Integrales' },
  { id: 3163, code: 'CO308', name: 'Judicial' },
  { id: 3164, code: 'MX308', name: 'Judicial' },
  { id: 3165, code: 'MX289', name: 'Líneas Financieras' },
  { id: 3166, code: 'CO326', name: 'Lucro Cesante' },
  { id: 3167, code: 'CO292', name: 'Manejo Individual' },
  { id: 3168, code: 'MX170', name: 'Marítimo' },
  { id: 3169, code: 'MX171', name: 'Marítimo Y Aviación' },
  { id: 3170, code: 'BR170', name: 'Maritimos (Cascos)' },
  { id: 3171, code: 'CO386', name: 'Mascotas Medicina Veterinaria' },
  { id: 3172, code: 'BR364', name: 'Medicina Ocupacional - Pcmso' },
  { id: 3173, code: 'CO390', name: 'Medicina Prepagada' },
  { id: 3174, code: 'CL183', name: 'Moto' },
  { id: 3175, code: 'MX381', name: 'Moto Flotilla' },
  { id: 3176, code: 'MX361', name: 'Moto Individual' },
  { id: 3177, code: 'AR183', name: 'Motovehículos' },
  { id: 3178, code: 'MX348', name: 'Múltiple' },
  { id: 3179, code: 'PE348', name: 'Multirriesgo' },
  { id: 3180, code: 'CO348', name: 'Multirriesgo' },
  { id: 3181, code: 'BR172', name: 'Objetos De Arte E Colecoes (Exposicoes)' },
  {
    id: 3182,
    code: 'BR191',
    name: 'Obras Civis Em Constr. Instalacao/Montagem',
  },
  { id: 3183, code: 'BR192', name: 'Obras Civis Em Construcao' },
  { id: 3184, code: 'PE374', name: 'Oncológico' },
  { id: 3185, code: 'BR375', name: 'One-off Policy' },
  { id: 3186, code: 'BR444', name: 'Penhor Rural' },
  { id: 3187, code: 'CL473', name: 'Perdida Total' },
  { id: 3188, code: 'CO164', name: 'Plan Alterno' },
  { id: 3189, code: 'CO176', name: 'Plan Azul' },
  { id: 3190, code: 'CO490', name: 'Plan Complementario' },
  { id: 3191, code: 'CO229', name: 'Plan Diamante' },
  { id: 3192, code: 'CO496', name: 'Plan Esmeralda' },
  { id: 3193, code: 'CO388', name: 'Plan Evoluciona' },
  { id: 3194, code: 'CO198', name: 'Plan Evoluciona Colectivo' },
  { id: 3195, code: 'CO283', name: 'Plan Humana Plus' },
  { id: 3196, code: 'CO341', name: 'Plan Medisanitas' },
  { id: 3197, code: 'CO226', name: 'Plan Odontologico' },
  { id: 3198, code: 'CO380', name: 'Plan Original' },
  { id: 3199, code: 'CO445', name: 'Plan Zafiro' },
  { id: 3200, code: 'BR449', name: 'Prestacao De Servicos' },
  {
    id: 3201,
    code: 'BR244',
    name: 'Prestamista Exc. Habit/rural - P. Coletivos',
  },
  { id: 3202, code: 'BR245', name: 'Prestamista Exce. Habit/Rural - P. Ind.' },
  {
    id: 3203,
    code: 'CL382',
    name: 'Programa De Seguro Controlado Por El Propietario',
  },
  { id: 3204, code: 'CL397', name: 'Property' },
  { id: 3205, code: 'BR379', name: 'R. C. Facultativa Para Aeronaves - Rcf' },
  { id: 3206, code: 'BR408', name: 'R.C. Armazens Gerais E Similares' },
  {
    id: 3207,
    code: 'BR402',
    name: 'R.C. Clubes, Agremiacoes E Assoc. Recreativa',
  },
  { id: 3208, code: 'BR404', name: 'R.C. Concessionarias' },
  { id: 3209, code: 'BR403', name: 'R.C. Cond. Prop. E Locatario De Imovel' },
  { id: 3210, code: 'BR105', name: 'R.C. Estab. Industriais E/Ou Comerciais' },
  { id: 3211, code: 'BR399', name: 'R.C. Estab.hospedagem/Bares E Similares' },
  { id: 3212, code: 'BR405', name: 'R.C. Estabelecimentos De Ensino' },
  { id: 3213, code: 'BR409', name: 'R.C. Guarda De Embarcacoes De Terceiros' },
  { id: 3214, code: 'BR410', name: 'R.C. Guarda De Veiculos De Terceiros' },
  { id: 3215, code: 'BR401', name: 'R.C. Obras Civis/Instalacao E Montagem' },
  {
    id: 3216,
    code: 'BR414',
    name: 'R.C. Operacoes Carga/Descarga - Cob. Ampla',
  },
  {
    id: 3217,
    code: 'BR425',
    name: 'R.C. Prest. De Serv. Em Locais De Terceiros',
  },
  {
    id: 3218,
    code: 'BR416',
    name: 'R.C. Prof. Arquitetura/engenharia/agronomia',
  },
  { id: 3219, code: 'BR421', name: 'R.C. Prof. Cartorios/notarios' },
  { id: 3220, code: 'BR394', name: 'R.C. Prof. Corretores De Seguros' },
  { id: 3221, code: 'BR420', name: 'R.C. Prof. Estab Medicos / Odontologicos' },
  {
    id: 3222,
    code: 'BR417',
    name: 'R.C. Prof. Proj. O. Civis, Inst. Montagens',
  },
  {
    id: 3223,
    code: 'BR418',
    name: 'R.C. Prof. Saude, Hosp, Clinicas E Similares',
  },
  { id: 3224, code: 'BR126', name: 'R.C. Profissional' },
  { id: 3225, code: 'BR422', name: 'R.C. Profissional - Miscellaneous' },
  {
    id: 3226,
    code: 'BR423',
    name: 'R.C. Promo Evento Artist. Esport E Similares',
  },
  {
    id: 3227,
    code: 'BR424',
    name: 'R.C. Promotores De Exp. E Feiras De Amostras',
  },
  { id: 3228, code: 'BR415', name: 'R.C. Risco De Petroleo E Gas' },
  {
    id: 3229,
    code: 'BR426',
    name: 'R.C. Transportador Aquaviario Carga - Rca-c',
  },
  {
    id: 3230,
    code: 'BR400',
    name: 'R.C. Transportador Desvio De Carga - Rcf-dc',
  },
  { id: 3231, code: 'BR427', name: 'R.C.F. Danos Materiais E/ou Pessoais' },
  { id: 3232, code: 'BR428', name: 'R.C.F.V Veiculos - Onibus' },
  { id: 3233, code: 'BR429', name: 'R.C.O.T.M - C Operador Transp Multimodal' },
  {
    id: 3234,
    code: 'BR301',
    name: 'R.C.T. Rodoviario Inter. E Intern. RC Onibus',
  },
  { id: 3235, code: 'BR146', name: 'R.C.T.A.C Do Transportador Aereo Carga' },
  {
    id: 3236,
    code: 'BR430',
    name: 'R.C.T.F.C Do Transportador Ferroviario Carga',
  },
  {
    id: 3237,
    code: 'BR431',
    name: 'R.C.T.R.C Transportador Rodoviario De Carga',
  },
  {
    id: 3238,
    code: 'BR432',
    name: 'R.C.T.R.VI-C Transp. Carga Em Viagem Intern',
  },
  { id: 3239, code: 'BR433', name: 'R.D. Equipamentos' },
  { id: 3240, code: 'CL187', name: 'RC Ambiental' },
  { id: 3241, code: 'CL406', name: 'RC Exceso' },
  { id: 3242, code: 'CL105', name: 'RC General' },
  { id: 3243, code: 'CL188', name: 'RC General Y De Producto' },
  { id: 3244, code: 'CL413', name: 'RC Internacional' },
  { id: 3245, code: 'CL126', name: 'RC Profesional' },
  { id: 3246, code: 'UY434', name: 'RDS' },
  { id: 3247, code: 'CO284', name: 'Renta Ideal' },
  { id: 3248, code: 'AR207', name: 'Resp. Civil Comprensiva' },
  { id: 3249, code: 'AR190', name: 'Resp. Civil Medica' },
  { id: 3250, code: 'AR126', name: 'Resp. Civil Profesional' },
  { id: 3251, code: 'BR439', name: 'Resp. Do Expl. Ou Transp. Aereo - Reta' },
  { id: 3252, code: 'AR105', name: 'Responsabilidad Civil' },
  { id: 3253, code: 'MX105', name: 'Responsabilidad Civil' },
  { id: 3254, code: 'PE105', name: 'Responsabilidad Civil' },
  { id: 3255, code: 'UY105', name: 'Responsabilidad Civil' },
  { id: 3256, code: 'CO187', name: 'Responsabilidad Civil Ambiental' },
  { id: 3257, code: 'CO185', name: 'Responsabilidad Civil Cumplimiento' },
  {
    id: 3258,
    code: 'CO186',
    name: 'Responsabilidad Civil Cumplimiento Renovar',
  },
  {
    id: 3259,
    code: 'BR110',
    name: 'Responsabilidad Civil De Directores Y Ejecutivos (D&O)',
  },
  {
    id: 3260,
    code: 'CL110',
    name: 'Responsabilidad Civil De Directores Y Ejecutivos (D&O)',
  },
  { id: 3261, code: 'CO105', name: 'Responsabilidad Civil General' },
  { id: 3262, code: 'CL333', name: 'Responsabilidad Civil Marítima' },
  { id: 3263, code: 'CO190', name: 'Responsabilidad Civil Medica' },
  { id: 3264, code: 'CO126', name: 'Responsabilidad Civil Profesional' },
  { id: 3265, code: 'CL243', name: 'Responsabilidad Civil Profesional (E&O)' },
  {
    id: 3266,
    code: 'CL394',
    name: 'Responsabilidad Civil Profesional Para Corredores',
  },
  { id: 3267, code: 'BR488', name: 'Responsabilidade Civil De Veiculos' },
  {
    id: 3268,
    code: 'BR189',
    name: 'Responsabilidade Civil Do Construtor Naval',
  },
  { id: 3269, code: 'BR247', name: 'Responsabilidade Civil Familiar' },
  { id: 3270, code: 'BR268', name: 'Responsabilidade Civil Hangar' },
  {
    id: 3271,
    code: 'BR187',
    name: 'Responsabilidade Civil Poluicao Ambiental',
  },
  { id: 3272, code: 'BR188', name: 'Responsabilidade Civil Produtos' },
  { id: 3273, code: 'AR200', name: 'Retiro Colectivo' },
  { id: 3274, code: 'BR109', name: 'Riscos Ciberneticos' },
  {
    id: 3275,
    code: 'BR368',
    name: 'Riscos De Petroleo - Off Shore (Plataforma)',
  },
  { id: 3276, code: 'BR487', name: 'Riscos Diversos' },
  { id: 3277, code: 'BR342', name: 'Riscos Diversos Financeiros' },
  { id: 3278, code: 'BR353', name: 'Riscos Nomeados' },
  { id: 3279, code: 'BR101', name: 'Riscos Operacionais' },
  { id: 3280, code: 'CL278', name: 'Robo' },
  { id: 3281, code: 'PE278', name: 'Robo Y Asalto' },
  { id: 3282, code: 'AR278', name: 'Robo Y Riesgos Similares' },
  { id: 3283, code: 'CO327', name: 'Rotura De Maquinaria' },
  { id: 3284, code: 'BR278', name: 'Roubo' },
  { id: 3285, code: 'MX137', name: 'Sabotaje Y Terrorismo' },
  { id: 3286, code: 'UY269', name: 'Salud' },
  { id: 3287, code: 'CO193', name: 'Salud Clasico Colectivo' },
  { id: 3288, code: 'CO194', name: 'Salud Clasico Familiar' },
  { id: 3289, code: 'CO199', name: 'Salud Global Colectivo' },
  { id: 3290, code: 'CO265', name: 'Salud Global Familiar' },
  { id: 3291, code: 'CO270', name: 'Salud Para Todos' },
  { id: 3292, code: 'CO271', name: 'Salud Para Todos Colectivo' },
  { id: 3293, code: 'BR273', name: 'Saude Pos Pagamento' },
  { id: 3294, code: 'BR269', name: 'Saude Pre Pagamento' },
  { id: 3295, code: 'BR143', name: 'Seguro Agricola Com Cobertura Do Fesr' },
  { id: 3296, code: 'BR144', name: 'Seguro Agricola Sem Cobertura Do Fesr' },
  { id: 3297, code: 'BR166', name: 'Seguro Animais' },
  {
    id: 3298,
    code: 'BR296',
    name: 'Seguro Benfeitorias E Produtos Agropecuarios',
  },
  {
    id: 3299,
    code: 'PE493',
    name: 'Seguro Complementario De Trabajo De Riesgo (SCTR)',
  },
  { id: 3300, code: 'CO108', name: 'Seguro De Credito' },
  { id: 3301, code: 'BR104', name: 'Seguro De Frota' },
  { id: 3302, code: 'AR269', name: 'Seguro De Salud' },
  { id: 3303, code: 'CO236', name: 'Seguro Educativo' },
  { id: 3304, code: 'BR257', name: 'Seguro Florestas Sem Cobertura Do Fesr' },
  { id: 3305, code: 'CO328', name: 'Seguro Obligatorio' },
  {
    id: 3306,
    code: 'PE332',
    name: 'Seguro Obligatorio De Accidentes De Tránsito (SOAT)',
  },
  { id: 3307, code: 'CO331', name: 'Seguro Obligatorio Sai' },
  { id: 3308, code: 'BR324', name: 'Seguro Pecuario Sem Cobertura Do Fesr' },
  { id: 3309, code: 'AR469', name: 'Seguro Tecnico' },
  { id: 3310, code: 'MX108', name: 'Seguros De Crédito' },
  { id: 3311, code: 'CL127', name: 'Seguros De Garantía' },
  { id: 3312, code: 'AR495', name: 'Sepelio' },
  { id: 3313, code: 'AR179', name: 'Servicios Medicos Caa' },
  { id: 3314, code: 'AR195', name: 'Servicios Medicos Cli' },
  { id: 3315, code: 'AR340', name: 'Servicios Medicos Inc' },
  { id: 3316, code: 'AR290', name: 'Servicios Medicos Ind' },
  { id: 3317, code: 'BR450', name: 'Servicos' },
  { id: 3318, code: 'CO278', name: 'Sustraccion' },
  { id: 3319, code: 'AR468', name: 'Técnico' },
  { id: 3320, code: 'MX235', name: 'Técnicos' },
  { id: 3321, code: 'BR129', name: 'Terrorismo' },
  { id: 3322, code: 'CL129', name: 'Terrorismo' },
  {
    id: 3323,
    code: 'CL470',
    name: 'Terrorismo / Huelga Disturbios Y Comisión Civil (SRCC)',
  },
  { id: 3324, code: 'BR181', name: 'Titulo De Capitalizacao' },
  { id: 3325, code: 'CL161', name: 'Todo Riesgo Bienes Fisicos' },
  { id: 3326, code: 'CL102', name: 'Todo Riesgo Construccion' },
  { id: 3327, code: 'CO102', name: 'Todo Riesgo Construccion' },
  { id: 3328, code: 'CL155', name: 'Todo Riesgo Construcción Y Montaje' },
  {
    id: 3329,
    code: 'CL154',
    name: 'Todo Riesgo Construcción Y Montaje / RC / DSU',
  },
  { id: 3330, code: 'CO101', name: 'Todo Riesgo Daño Material' },
  {
    id: 3331,
    code: 'PE209',
    name: 'Todo Riesgo Equipo De Contratistas (TREC)',
  },
  { id: 3332, code: 'PE111', name: 'Todo Riesgo Equipo Electrónico (EE)' },
  { id: 3333, code: 'CO158', name: 'Todo Riesgo Equipo Y Maquinaria' },
  { id: 3334, code: 'PE153', name: 'Todo Riesgo Montaje (EAR)' },
  { id: 3335, code: 'CO159', name: 'Todo Riesgo Montaje Maquinaria' },
  { id: 3336, code: 'CL163', name: 'Todo Riesgo Objetos Valiosos' },
  { id: 3337, code: 'CL101', name: 'Todo Riesgo Operaciones' },
  { id: 3338, code: 'AR101', name: 'Todo Riesgo Operativo' },
  { id: 3339, code: 'UY101', name: 'Todo Riesgo Operativo' },
  { id: 3340, code: 'CL107', name: 'Todo Riesgo Para Contratistas (CAR)' },
  { id: 3341, code: 'PE107', name: 'Todo Riesgo Para Contratistas (CAR)' },
  { id: 3342, code: 'BR474', name: 'Transp. RCTR-C - Estipulacao' },
  { id: 3343, code: 'CL130', name: 'Transporte' },
  { id: 3344, code: 'CO475', name: 'Transporte De Valores' },
  { id: 3345, code: 'CL452', name: 'Transporte Específico Internacional' },
  { id: 3346, code: 'BR113', name: 'Transporte Exportacao' },
  { id: 3347, code: 'BR246', name: 'Transporte Exportacao/Importacao' },
  { id: 3348, code: 'CL254', name: 'Transporte Flat' },
  { id: 3349, code: 'BR288', name: 'Transporte Importacao' },
  { id: 3350, code: 'CL305', name: 'Transporte Internacional' },
  { id: 3351, code: 'CL304', name: 'Transporte Internacional Terrestre' },
  { id: 3352, code: 'CL335', name: 'Transporte Maritimo' },
  { id: 3353, code: 'CL446', name: 'Transporte Marítimo, Aéreo Y Terrestre' },
  { id: 3354, code: 'CL350', name: 'Transporte Multiriesgo' },
  { id: 3355, code: 'BR124', name: 'Transporte Nacional' },
  { id: 3356, code: 'CL124', name: 'Transporte Nacional' },
  { id: 3357, code: 'CL354', name: 'Transporte Nacional E Internacional' },
  { id: 3358, code: 'CL309', name: 'Transporte Terrestre' },
  { id: 3359, code: 'CL355', name: 'Transporte Terrestre Nacional' },
  { id: 3360, code: 'MX130', name: 'Transportes' },
  { id: 3361, code: 'AR130', name: 'Transportes' },
  { id: 3362, code: 'PE130', name: 'Transportes' },
  { id: 3363, code: 'UY130', name: 'Transportes' },
  { id: 3364, code: 'CO130', name: 'Transportes (Automática)' },
  { id: 3365, code: 'CO131', name: 'Transportes (Específica)' },
  { id: 3366, code: 'BR338', name: 'Vale Refeicao' },
  { id: 3367, code: 'BR486', name: 'Valores No Interior Do Estabelecimento' },
  { id: 3368, code: 'CL391', name: 'Vehiculo Particular' },
  { id: 3369, code: 'CL132', name: 'Vehículos' },
  { id: 3370, code: 'PE132', name: 'Vehículos' },
  { id: 3371, code: 'UY132', name: 'Vehículos' },
  { id: 3372, code: 'CL321', name: 'Vehículos Comercial Livianos' },
  { id: 3373, code: 'CL203', name: 'Vehículos Comerciales' },
  { id: 3374, code: 'CL323', name: 'Vehiculos Livianos' },
  { id: 3375, code: 'CL347', name: 'Vehículos Motorizados' },
  { id: 3376, code: 'CL276', name: 'Vehiculos Pesados' },
  { id: 3377, code: 'BR200', name: 'Vgbl/Vagp/Vrgp/Vrsa/Vri - P. Coletivos' },
  { id: 3378, code: 'BR476', name: 'Viagem - Pessoas Coletivos' },
  { id: 3379, code: 'BR477', name: 'Viagem - Pessoas Individual' },
  { id: 3380, code: 'CL120', name: 'Vida' },
  { id: 3381, code: 'PE120', name: 'Vida' },
  { id: 3382, code: 'UY120', name: 'Vida' },
  { id: 3383, code: 'BR371', name: 'Vida - P. Coletivos' },
  { id: 3384, code: 'BR314', name: 'Vida - Pessoas Individual' },
  {
    id: 3385,
    code: 'AR315',
    name: 'Vida – Sin Constitución De Reservas Matemáticas',
  },
  { id: 3386, code: 'AR106', name: 'Vida Colectivo' },
  { id: 3387, code: 'MX106', name: 'Vida Colectivo' },
  { id: 3388, code: 'UY106', name: 'Vida Colectivo' },
  { id: 3389, code: 'AR320', name: 'Vida Convenio Mercantil 130/75' },
  { id: 3390, code: 'CO134', name: 'Vida Grupo' },
  { id: 3391, code: 'AR118', name: 'Vida Individual' },
  { id: 3392, code: 'CO118', name: 'Vida Individual' },
  { id: 3393, code: 'MX118', name: 'Vida Individual' },
  { id: 3394, code: 'UR118', name: 'Vida Individual' },
  { id: 3395, code: 'AR319', name: 'Vida Ley Contrato De Trabajo' },
  { id: 3396, code: 'AR363', name: 'Vida Obligatorio (Decreto 1567/74)' },
  { id: 3397, code: 'AR330', name: 'Vida Obligatorio (Trabajadores Rurales)' },
  {
    id: 3398,
    code: 'AR329',
    name: 'Vida Obligatorio (Trabajodres Domesticos)',
  },
  { id: 3399, code: 'CL316', name: 'Vida Y Salud' },
];
